<script>
import Multiselect from "@vueform/multiselect";
import Layout from "../../layouts/main";
import PageHeader from "@/components/page-header";
import appConfig from "@/app.config";
import useVuelidate from "@vuelidate/core";
import {helpers, required, requiredIf} from "@vuelidate/validators";
import Swal from "sweetalert2";
import Loader from "../components/loader";
import api from "@/axios";
import moment from "moment/moment";
import router from "@/router";
import DropZone from "@/components/widgets/dropZone.vue";
import { ref } from "vue";
import {getBaseUrl} from "@/helpers/baseUrl";

export default {
  page: {
    title: "Editar Lançamento Financeiro",
    meta: [{ name: "description", content: appConfig.description }],
  },
  components: { DropZone, Layout, PageHeader, Loader, Multiselect },
  setup() {

    let dropzoneFile = ref("");
    const drop = (e) => {
      dropzoneFile.value = e.dataTransfer.files[0]
    };

    return { v$: useVuelidate(), dropzoneFile, drop };
  },
  data() {
    return {
      showModalAnexo: false,
      submittedAnexo: false,
      descranexo: '',
      mediasData: {},
      loadingFiles: false,

      dataBaixa: new Date(),
      showModalBaixaParc: false,
      vlrTotalParcs: 0,
      parcVerifica: 0,
      regSelFinParc: {},
      flagValorJuros: 'vlr',
      flagTipoJuros: 'dia',
      showModalFinanParc: false,
      finanBoletoData: null,
      mediaBase64Data: null,
      dtListPesqFinConta: null,
      finContaData: {
        codigo: '02',
        descricao: 'Receitas'
      },
      naturezaData: {
        id: null,
        descricao: "Lançamento Avulso"
      },
      priVencto: moment(new Date()).format('YYYY-MM-DD'),
      intervParcelas: 30,
      qtdParcelas: 1,
      dtListPesqConta:null,
      dtListPesqFormaPgto: null,
      dtlistPesqNatureza: null,
      loadingConta:false,
      loadingFormaPgto: false,
      loadingNatureza:false,
      dtlistPesqCategoria: null,
      loadingCategoria:false,
      dtListPesqCli: null,
      loadingParcelas: false,
      loadingCFOPs: false,
      submitFinanc: false,
      submitFinanParc: false,
      finanparcData: {},
      finanCaixaData: {},
      loadingFinanceiro: false,
      dtListPesqCFOP: null,
      dtListPesqProduto: null,
      showModalParcela: false,
      showModalEditRecorrencia: false,
      errosValid: null,
      contClickAvanc: 0,
      pessoaData: null,
      financeiroData: {
        id: 0,

        // pessoa: '00121', //mock
        // categoria: 'TB', // mock
        // formapgto: '10',  // mock
        banco_id: null,
        categoria: null,
        dtbaixa: null,

        status: 'A',
        stsbaixa: 'AB',
        tipo: "R",
        conta: '02',

        emissao: moment(new Date()).format('YYYY-MM-DD'),
        vencimento: moment(new Date()).add(30, 'days').format('YYYY-MM-DD'),
        primeiro_vencimento: moment(new Date()).add(30, "days").format("YYYY-MM-DD"),
        compet: null,
        banco: null,

        condpgto: "11",
        ocorrencia: 'COND',
        qtdparc: 1,
        consutil: false,
        emissaofixa: false,
        vencimentofixo: false,
        qtdrecorrencia: 1,
        atributorecorrencia: 'FINA',
        intervParcelasRecorrencia: 30,
        intervParcCondPgto: '',
        formatorenegociacao: false,
        ContaData: {}
      },
      totalCaixaData: 0,
      reconfigreco: false,
      finanParcsData: null,
      enderecosData: {},
      idData: 0,
      updating: true,
      activeTab: 0,
      submitted: false,

      loadingCondPgto: false,
      condPgtoData: {
        'codigo': '',
        'descricao': ''
      },
      dtListPesqCondPgto: null,
      showModalCondPgto: false,

      ContaData: {},

      title: "Editar Lançamento Financeiro a Receber",
      items: [
        {
          text: "Contas a Receber",
          href: "/financeiros/contasreceber",
        },
        {
          text: "Editar Lançamento Financeiro a Receber",
          active: true,
        },
      ],

      baixaParcela: {
        valor: 0.00,
        dtbaixa: null,
        caixa: null
      },

      flagBaixaMenorVlrGeraParc: false,

      submittedRecorr: false,
      recorrdtbaixa: moment().format('YYYY-MM-DD'),
      currentTab: 'alteraRecorrencia', // Aba inicial
      tabs: [
        { name: 'alteraRecorrencia', label: 'Altera Recorrência' },
        { name: 'quitaRecorrencia', label: 'Quita Recorrência' },
        { name: 'deletaRecorrencia', label: 'Deleta Recorrência' },
      ],

      isRenegotiating: false,
      renegociacoesData: [],

      showModalPagBank: false,
      pagbankLoading: false,
      pagbankFinanparcId: null,
      pagbankSoftdescriptor: '',
      pagbankQtdparcelas: 1,
      pagbankQtdparcelassemjuros: 0,
      pagbankLinkGerado: null,
      pagbankVerLinkLoading: false,
      pagbankInativarLoading: false,
    };
  },
  validations: {
    financeiroData: {
      pessoa: {
        required: helpers.withMessage("Campo fornecedor obrigatório, favor preencher.", required),
      },
      codigo: {
        required: helpers.withMessage("Campo Código obrigatório, favor preencher.", required),
      },
      numero: {
        required: helpers.withMessage("Campo Número obrigatório, favor preencher.", required),
      },
      emissao: {
        required: helpers.withMessage("Campo Data de emissão obrigatório, favor preencher.", required),
      },
      natureza: {
        required: helpers.withMessage("Campo Natureza obrigatório, favor preencher.",
            requiredIf(() => {
              return this.financeiroData.tabela && this.financeiroData.origem_id;
            })
        )
      },

      formapgto: {
        required: helpers.withMessage("Campo Forma de Pagamento obrigatório, favor preencher.", required),
      },
      categoria: {
        required: helpers.withMessage("Campo Categoria obrigatório, favor preencher.", required),
      },
      banco_id: {
        required: helpers.withMessage("Campo Banco obrigatório, favor preencher.", required),
      },
      valor: {
        required: helpers.withMessage("Campo Valor deve ser maior que zero, favor preencher.", required),
      },
      ocorrencia: {
        required: helpers.withMessage("Campo ocorrência obrigatório, favor preencher.", required),
      },
      qtdparc: {
        required: helpers.withMessage("Campo quant. de parcelas obrigatório, favor preencher.", required),
      },
      qtdrecorrencia: {
        required: helpers.withMessage("Campo Dias de recorrência obrigatório, favor preencher.", required),
      },
      intervParcelasRecorrencia: {
        required: helpers.withMessage("Campo Intervalo de recorrência obrigatório, favor preencher.", required),
      }
    },
    finanparcData: {
      cfop: {
        required: helpers.withMessage("Campo CFOP obrigatório, favor preencher.", required),
      },
    }
  },
  methods: {
    desassociarExtrato(data){
      console.log('desassociarExtrato')

      const idExtrato = data.extrato_id;
      const idData = data.id;

      Swal.fire({
        position: "center",
        icon: "warning",
        title: `Deseja realmente desassociar o Extrato ${idExtrato} da parcela financeira ${idData} ?`,
        showConfirmButton: true,
        showCancelButton: true,
        confirmButtonText: "Confirmar",
        cancelButtonText: "Cancelar",
      }).then((confirmed) => {
        if(confirmed.isConfirmed) {
          api.delete(`${getBaseUrl()}api/desassextratofinan`, {
            params: { iddata: idData }
          }).then((res) => {
            console.log('then axios desassocextratofinan')
            console.log(JSON.stringify(res.data))

            if(res.data.success){
              Swal.fire({
                position: "top-end",
                icon: "success",
                title: res.data.message,
                showConfirmButton: false,
                timer: 1500
              }).then(() => {
                this.carregarDados()
              })
            } else {
              Swal.fire({
                position: "top-end",
                icon: "error",
                title: res.data.error,
                showConfirmButton: false,
                timer: 3000
              }).then(() => {
                this.carregarDados()
              })
            }
          })
        }
      })
    },

    downFile(path, nomeArq) {
      console.log('downFile: ' + path)
      //console.log('downFile: ' + path.split('.').pop())
      this.loadingFiles = true
      api.get(`${getBaseUrl()}api/getfile`, {
        responseType: 'blob',
        params: { pathData: path }
      }).then((res) => {
        console.log('res down')
        console.log(res)
        var fileURL = window.URL.createObjectURL(new Blob([res.data]));
        var fileLink = document.createElement('a');
        fileLink.href = fileURL;
        fileLink.setAttribute('download', nomeArq);
        document.body.appendChild(fileLink);
        console.log('fileLink')
        console.log(fileURL)
        fileLink.click();
        this.loadingFiles = false
      })
    },

    delFile(dataID) {
      console.log('deletar: ' + dataID)
      Swal.fire({
        position: "center",
        icon: "question",
        title: "Exclusão de Registro",
        text: "Esta operação é irreversível, tem certeza que deseja continuar?",
        confirmButtonText: "Confirmar",
        cancelButtonText: "Cancelar",
        showCancelButton: true,
        showConfirmButton: true,
      }).then(result => {
        if (result.value) {
          this.loadingFiles = true
          api.delete(`${getBaseUrl()}api/media`, {
            params: {
              'iddata': dataID
            }
          }).then((res) => {
            console.log('then axios delete')
            console.log(res.data)
            //this.atualizaDataList()
            Swal.fire({
              position: "top-end",
              icon: "success",
              title: "Informações excluídas com sucesso!",
              showConfirmButton: false,
              timer: 1500
            })
            this.loadingFiles = false
            this.mediasData = res.data[0]
          })
        }
      })
    },


    selectedFile() {
      console.log('selectedFile')
      this.dropzoneFile = document.querySelector(".dropzoneFile").files[0]
      console.log('selectedFile')

    },

    novoAnexo() {
      console.log('novoAnexo')
      this.descranexo = ''
      this.submittedAnexo = false
      this.showModalAnexo = true
      // this.activeTab = 2
    },

    confAnexo() {
      console.log('confAnexo')
      this.submittedAnexo = true
      if (this.descranexo !== '' && this.dropzoneFile.name) {
        this.showModalAnexo = false
        this.loadingFiles = true

        let arquivo = document.querySelector(".dropzoneFile").files[0]
        console.log(arquivo)
        let formData = new FormData()
        formData.append("iddata", this.idData)
        formData.append("descranexo", this.descranexo)
        formData.append("filename", arquivo.name)
        formData.append("file", arquivo)

        api.post(`${getBaseUrl()}api/financfile`, formData, {
          headers: {
            'Content-Type': 'multipart/form-data'
          }
        }).then((res) => {
          console.log('then axios')
          console.log(res)
          this.mediasData = res.data[0]
          this.loadingFiles = false

          Swal.fire({
            position: "top-end",
            icon: "success",
            title: "Informações salvas com sucesso!",
            showConfirmButton: false,
            timer: 1500
          })

        }).catch((err) => {

          console.log('erro axios')
          // console.log(err)
          // console.log(err.response)
          // console.log(err.response.data.errors)
          let erros = err.response.data.errors
          console.log(erros)
          console.log(typeof erros)
          let listaErros = []
          Object.keys(erros).forEach(key => {
            console.log(key, erros[key]);
            listaErros.push({
              'titulo': key,
              'mensagem': erros[key]
            })
          });
          this.errosValid = listaErros
          this.loadingFiles = false
        })
      }
    },


    excluirLancto() {
      console.log('excluirLancto')
      Swal.fire({
        position: "center",
        icon: "question",
        title: "Exclusão de Registro",
        text: "Esta operação é irreversível, tem certeza que deseja continuar?",
        confirmButtonText: "Confirmar",
        cancelButtonText: "Cancelar",
        showCancelButton: true,
        showConfirmButton: true,
      }).then(result => {
        if (result.value) {
          this.updating = true
          api.delete(`${getBaseUrl()}api/financeiro`, {
            params: {
              'iddata': this.idData
            }
          }).then((res) => {
            console.log('then axios delete')
            console.log(res.data)

            if (res.data[0] === 'sucesso') {
              Swal.fire({
                position: "top-end",
                icon: "success",
                title: res.data[1],
                showConfirmButton: false,
                timer: 1500
              }).then(() => {
                router.push('/financeiros/contasreceber');
              })
            } else if (res.data[0] === 'erro') {
              Swal.fire({
                position: "top-end",
                icon: "error",
                title: res.data[1],
                showConfirmButton: false,
                timer: 2500
              })
              this.updating = false
            }

          })
        }
      })
    },


    gerarCaixa() {
      console.log('gerarCaixa')
      console.log(this.idData)

      if (!this.financeiroData.banco) {
        Swal.fire({
          position: "center",
          icon: "warning",
          title: "Falta selecionar banco",
          text: "Essa conta não possui banco, por favor, selecione um banco para continuar!",
        })
      } else {
        Swal.fire({
          position: "center",
          icon: "question",
          title: "Gerar Caixa",
          text: "Esta operação é irreversível, tem certeza que deseja continuar?",
          confirmButtonText: "Confirmar",
          cancelButtonText: "Cancelar",
          showCancelButton: true,
          showConfirmButton: true,
        }).then(result => {
          if (result.value) {

            api.get(`${getBaseUrl()}api/gerarcaixa`, {
              params: {iddata: this.idData}
            }).then((res) => {
              console.log('then axios gerar caixa')
              console.log(res)

              Swal.fire({
                position: "top-end",
                icon: "success",
                title: "Informação inclusa com sucesso!",
                showConfirmButton: false,
                timer: 1500
              })

              // this.mediaBase64Data = res.data[0]
              // this.imprimirBoleto()
              // this.updating = false
            })
          }
        })
      }
    },


    confirmarBaixa() {
      console.log('confirmarBaixa')

      console.log(`
        valor baixa atual: ${this.baixaParcela.valor}
        parcela atual: ${this.regSelFinParc.valor}
        parcela juros: ${this.regSelFinParc.juros}
        parcela desconto: ${this.regSelFinParc.desconto}
      `)
      if (this.baixaParcela.valor > this.regSelFinParc.valor + this.regSelFinParc.juros) {
        Swal.fire({
          position: 'top-end',
          icon: 'warning',
          text: 'Valor da baixa não pode ser superior ao valor da parcela atual!',
          showConfirmButton: false,
          showCancelButton: false,
          timer: 5000
        })
      } else if(this.baixaParcela.valor < this.regSelFinParc.valor + this.regSelFinParc.juros) {
        Swal.fire({
          position: "center",
          icon: "question",
          title: "Confirmação de Baixa",
          text: "O valor de pagamento é menor que o valor da parcela, deseja gerar nova parcela com o valor restante?",
          confirmButtonText: "Confirmar e gerar parcela",
          cancelButtonText: "Confirmar s/ gerar parcela ",
          showCancelButton: true,
          showConfirmButton: true,
        }).then((result) => {
          console.log('resultado é : ' , result)
          if(result.value){
            // console.log('confirmou e quer gerar parcela')
            this.flagBaixaMenorVlrGeraParc = true
          } else{
            // console.log('confirmou e Não quer gerar parcela com valor restante')
            this.flagBaixaMenorVlrGeraParc = false
          }
          this.loadingParcelas = true

          api.post(`${getBaseUrl()}api/baixaparc`, {
            finanparcData: this.regSelFinParc,
            baixaParcela: this.baixaParcela,
            flagBaixaMenorVlrGeraParc: this.flagBaixaMenorVlrGeraParc
          }).then((res) => {
            console.log('then axios')
            console.log(res)
            this.showModalBaixaParc = false

            Swal.fire({
              position: "top-end",
              icon: "success",
              title: "Lançamento baixado com sucesso!",
              showConfirmButton: false,
              timer: 1500
            }).then(() => {
              this.carregarDados()
            })
          })
        })


      } else {
        this.loadingParcelas = true

        api.post(`${getBaseUrl()}api/baixaparc`, {
          finanparcData: this.regSelFinParc,
          baixaParcela: this.baixaParcela,
          flagBaixaMenorVlrGeraParc: this.flagBaixaMenorVlrGeraParc
        }).then((res) => {
          console.log('then axios')
          console.log(res)
          this.showModalBaixaParc = false

          Swal.fire({
            position: "top-end",
            icon: "success",
            title: "Lançamento baixado com sucesso!",
            showConfirmButton: false,
            timer: 1500
          }).then(() => {
            this.carregarDados()
          })
        })
      }

    },


    baixarParcela(dataParcela) {
      console.log('baixarParcela')
      this.regSelFinParc = dataParcela
      this.regSelFinParc.dtbaixa = moment(new Date()).format('DD-MM-YYYY')

      this.baixaParcela.valor = (parseFloat(dataParcela.valor) + parseFloat(dataParcela.juros)) - parseFloat(dataParcela.desconto)
      this.baixaParcela.dtbaixa = moment(new Date()).format('YYYY-MM-DD')
      this.showModalBaixaParc = true
    },


    cancBaixarParcela(dataParcela) {
      console.log('baixarParcela')
      console.log(dataParcela.id)
      this.regSelFinParc = dataParcela


      Swal.fire({
        position: "center",
        icon: "question",
        title: "Cancelamento de Baixa",
        text: "Esta operação é irreversível, tem certeza que deseja continuar?",
        confirmButtonText: "Confirmar",
        cancelButtonText: "Cancelar",
        showCancelButton: true,
        showConfirmButton: true,

      }).then(result => {
        if (result.value) {
          this.loadingParcelas = true

          api.post(`${getBaseUrl()}api/baixaparccanc`, {
            finanparcData: this.regSelFinParc
          }).then((res) => {
            console.log('then axios')
            console.log(res)
            this.showModalBaixaParc = false

            Swal.fire({
              position: "top-end",
              icon: "success",
              title: "Baixa cancelada com sucesso!",
              showConfirmButton: false,
              timer: 1500
            }).then(() => {
              this.carregarDados()
            })
          })


        }
      })

    },

    baixarArquivoCnabParcela(data) {
      console.log('baixarArquivoCnabParcela')
      const bodyData = {idfinanparc: data.id}
      const responseType = {responseType: 'blob'};
      api.post(`${getBaseUrl()}api/emissaoBoletoRemessa`, bodyData, responseType).then((res) => {
        this.showModalBaixaParc = false
        
        Swal.fire({
          position: "top-end",
          icon: "success",
          title: "Arquivo Cnab gerado com sucesso!",
          showConfirmButton: false,
          timer: 1500
        })

        // download arquivo cnab
        console.log(res.headers)
        // const filename = res.headers['x-filename'];
        const filename = res.headers['x-filename'];
        const url = window.URL.createObjectURL(new Blob([res.data]));
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', filename);
        document.body.appendChild(link);
        link.click();
        link.remove();
      }).catch((error) => {
        console.log(error.response.data)
        const reader = new FileReader()
        reader.onload = () => {
          const errorData = JSON.parse(reader.result)
          Swal.fire({
            position: "top-end",
            icon: "error",
            title: "Erro ao gerar arquivo Cnab!\n" + errorData.error,
            showConfirmButton: false,
            timer: 1500
          })
        }
        reader.readAsText(error.response.data)
      })
    },

    selectTab(tab) {
      this.currentTab = tab;
    },

    carregarDados() {
      this.updating = true
      if (this.idData > 0) {
        api.get(`${getBaseUrl()}api/financeiro`, {
          params: { iddata: this.idData }
        }).then((res) => {
          console.log('then axios financeiro')
          console.log(res.data)

          if (res.data.error) {
            console.log(res.data.error)
            this.$router.push(`/faltapermissao`);
          } else {
            this.financeiroData = res.data[0]
            this.pessoaData = res.data[1]
            this.finanParcsData = res.data[2]
            
            this.financeiroData.primeiro_vencimento = moment(this.finanParcsData[0].vencimento).format("YYYY-MM-DD");

            this.finContaData = res.data[3]
            this.renegociacoesData = res.data[12]

            this.finanCaixaData = res.data[7]
            this.ContaData = res.data[8]

            this.financeiroData.emissao = moment(this.financeiroData.emissao).format('YYYY-MM-DD')

            if (this.pessoaData && this.pessoaData.id) {
              this.dtListPesqCli = [
                {
                  'codigo': this.pessoaData.codigo,
                  'nome': this.pessoaData.nome,
                }
              ]
            } else {
              this.dtListPesqCli = [
                {
                  'codigo': "",
                  'nome': "",
                }
              ]
            }

            console.log('finContaData')
            console.log(JSON.stringify(res.data[3]))
            if (this.finContaData && this.finContaData.id) {
              this.dtListPesqFinConta = [
                {
                  'codigo': this.finContaData.codigo,
                  'descricao': this.finContaData.descricao,
                }
              ]
            }
            console.log(JSON.stringify(this.dtListPesqFinConta))

            console.log('ContaData')
            console.log(JSON.stringify(res.data[8]))
            if (this.ContaData && this.ContaData.id){
              this.dtListPesqConta = [
                {
                  id: this.ContaData.id,
                  descricao: this.ContaData.descricao,
                }
              ]
            }
            console.log(JSON.stringify(this.dtListPesqConta))


            this.dtListPesqFormaPgto = res.data[9];


            console.log('categoriaData')
            console.log(JSON.stringify(res.data[10]))
            this.categoriaData = res.data[10];
            if (res.data[10]) {
              this.dtlistPesqCategoria = [
                {
                  id: res.data[10].id,
                  descricao: res.data[10].descricao,
                }
              ]
            }
            console.log(JSON.stringify(this.dtlistPesqCategoria))

            this.naturezaData = res.data[11];
            if (res.data[11]) {
              this.dtlistPesqNatureza = [
                {
                  id: res.data[11].id,
                  descricao: res.data[11].descricao,
                }
              ]
            }
            console.log(JSON.stringify(this.dtlistPesqNatureza))

            let totalParcelasLoc = 0
            this.finanParcsData.forEach((value) => {
              // value.emissao = moment(value.emissao).format('YYYY-MM-DD')
              // value.vencimento = moment(value.vencimento).format('YYYY-MM-DD')
              if (value.emissao) {
                value.emissao_fmt = moment(value.emissao).format('DD/MM/YYYY')
              }
              if (value.vencimento) {
                value.vencimento_fmt = moment(value.vencimento).format('DD/MM/YYYY')
              }
              if (value.dtbaixa) {
                value.dtbaixa_fmt = moment(value.dtbaixa).format('DD/MM/YYYY')
              }
              totalParcelasLoc = totalParcelasLoc + value.valor
            })
            this.vlrTotalParcs = totalParcelasLoc

            this.parcVerifica = this.financeiroData.valor - this.vlrTotalParcs

            this.idData = this.financeiroData.id
            if (this.pessoaData) {
              this.title = `${this.financeiroData.empresa} - Editar Lançamento Financeiro a Receber (${this.financeiroData.id}) ${this.pessoaData.nome}`
            } else {
              this.title = `${this.financeiroData.empresa} - Editar Lançamento Financeiro a Receber (${this.financeiroData.id})`
            }

            if(this.financeiroData.stsbaixa === 'QT'){

              const todasQuitadas = this.finanParcsData.every(parcela => parcela.status === 'QT');

              if(todasQuitadas) {
                const ultimaParc = [...this.finanParcsData]
                    .filter(parcela => parcela.dtbaixa)
                    .sort((a,b) => new Date(b.dtbaixa) - new Date(a.dtbaixa))[0];

                this.financeiroData.dtbaixa = ultimaParc ? ultimaParc.dtbaixa : null;
              } else {
                this.financeiroData.dtbaixa = null;
              }


            }

            this.updating = false
            this.loadingParcelas = false
          }
        });
      } else {
        this.title = `Criando Nova Conta a Receber`
        this.updating = false
        this.pesqCondPgto()
        this.pesqFormaPgto()
        this.pesqNatureza(this.naturezaData.descricao)
      }

    },

    formatNumber(value) {
      console.log('formatNumber: ' + value);
      console.log(typeof value);

      if (typeof value === 'string') {
        console.log('formatting number...');

        try {
          const formatted = value.replace(',', '.');
          console.log(formatted);

          return parseFloat(formatted);
        } catch (error) {
          console.log('error: number convertion failed...');
          console.log(error);

          return 0.00;
        }
      } else {
        return parseFloat(value);
      }
    },

    formSubmitFinanParc() {
      console.log('formSubmitFinanParc')
      console.log(this.regSelFinParc)
      this.updating = true
      this.loadingFinanceiro = true
      this.showModalFinanParc = false

      //Verificando flags de juros
      if ((this.flagValorJuros && this.flagValorJuros !== 'vlr') || (this.flagTipoJuros && this.flagTipoJuros !== 'dia')) {
        //se valor estiver em percentual converte para valor
        if (this.flagValorJuros === 'perc') {
          this.regSelFinParc.juros = (this.regSelFinParc.juros * this.regSelFinParc.valor) / 100;
          this.flagValorJuros = 'vlr'
        }

        //se juros calculado sempre ao dia, se passado ao mês necessário converter
        if (this.flagTipoJuros === 'mes') {
          this.regSelFinParc.juros = this.regSelFinParc.juros / 30;
        }
      }

      //Ajustando valores para numéricos
      this.regSelFinParc.valor = this.formatNumber(this.regSelFinParc.valor);
      this.regSelFinParc.juros = this.formatNumber(this.regSelFinParc.juros);
      this.regSelFinParc.desconto = this.formatNumber(this.regSelFinParc.desconto);

      api.post(`${getBaseUrl()}api/finanparc`, {
        finanparcData: this.regSelFinParc
      }).then((res) => {
        console.log('then axios')
        console.log(res)
        this.updating = false
        this.loadingFinanceiro = false
        this.carregarDados()
      })
    },

    atualizaPagina(){
      window.location.reload()
    },



    baixarBoleto() {
      console.log('baixarBoleto')

      Swal.fire({
        position: "center",
        icon: "question",
        title: "Baixa de Lançamento",
        text: "Esta operação é irreversível, tem certeza que deseja continuar?",
        confirmButtonText: "Confirmar",
        cancelButtonText: "Cancelar",
        showCancelButton: true,
        showConfirmButton: true,

      }).then(result => {
        if (result.value) {

          this.updating = true

          api.get(`${getBaseUrl()}api/fbolbaixa`, {
            params: { iddata: this.idData }
          }).then((res) => {
            console.log('then axios boleto')
            console.log(res)

            if (res.data[0]['status']['codigo'] === 400) {
              Swal.fire({
                position: "top-end",
                icon: "warning",
                title: "Erro na execução: " + res.data[0]['status']['mensagem'],
                showConfirmButton: false,
                timer: 1500
              })
            } else {

              Swal.fire({
                position: "top-end",
                icon: "success",
                title: "Lançamento baixado com sucesso!",
                showConfirmButton: false,
                timer: 1500
              })

            }

            // this.mediaBase64Data = res.data[0]
            // this.imprimirBoleto()

            this.updating = false
          })

        }

      })


    },


    prorrogarBoleto() {
      console.log('prorrogarBoleto')
      if (this.financeiroData.vencimento === this.finanBoletoData.vencimento) {
        Swal.fire({
          position: "top-end",
          icon: "warning",
          title: "Nova data de vencimento deve ser difierente da data anterior, favor corrigir.",
          showConfirmButton: false,
          timer: 1500
        })
      } else {
        this.updating = true

        api.get(`${getBaseUrl()}api/fbolpror`, {
          params: { iddata: this.idData }
        }).then((res) => {
          console.log('then axios boleto')
          console.log(res)

          if (res.data[0]['status']['codigo'] === 400) {
            Swal.fire({
              position: "top-end",
              icon: "warning",
              title: "Erro na execução: " + res.data[0]['status']['mensagem'],
              showConfirmButton: false,
              timer: 1500
            })
          } else {

            Swal.fire({
              position: "top-end",
              icon: "success",
              title: "Lançamento prorrogado com sucesso!",
              showConfirmButton: false,
              timer: 1500
            })

          }

          // this.mediaBase64Data = res.data[0]
          // this.imprimirBoleto()

          this.updating = false
        })
      }
    },

    imprimirBoleto() {
      console.log('imprimirBoleto')

      const linkSource = `data:application/pdf;base64,${this.mediaBase64Data.base64}`;
      const downloadLink = document.createElement("a");
      const fileName = `boleto_lancto_${this.idData}.pdf`;
      downloadLink.href = linkSource;
      downloadLink.download = fileName;
      downloadLink.click();
    },

    segundavia(finanParc) {
      console.log('imprimir2viaBoleto')

      api.get(`${getBaseUrl()}api/imprimirbolreceber`, {
        params: { iddata: finanParc.id }
      }).then((res) => {
        console.log('then axios 2via boleto')
        console.log(res)

        if (res.data.success) {
          this.mediaBase64Data = res.data.data
          this.imprimirBoleto()

          this.updating = false
        } else {
          Swal.fire({
            position: 'top-end',
            icon: 'error',
            title: res.data.data,
            showConfirmButton: false,
            timer: 3000
          }).then(() => {
            this.carregarDados()
          })
        }
      })
    },


    novoBoleto(finanParc) {
      console.log('novoBoleto')
      console.log(finanParc)
      this.updating = true

      api.get(`${getBaseUrl()}api/gerabolreceber`, {
        params: { iddata: finanParc.id }
      }).then((res) => {
        console.log('then axios boleto')
        console.log(res)

        if (res.data.success) {
          this.mediaBase64Data = res.data.data
          this.imprimirBoleto()

          this.updating = false
        } else {
          Swal.fire({
            position: 'top-end',
            icon: 'error',
            title: res.data.data,
            showConfirmButton: false,
            timer: 3000
          })
        }
        this.carregarDados()
      })
    },

    consultarBoleto(idparcela) {
      console.log('consultarBoleto')
      this.updating = true
      api.get(`${getBaseUrl()}api/fbolcons`, {
        params: { iddata: idparcela }
      }).then((res) => {
        console.log('then axios consboleto')
        console.log(res)

        this.updating = false

        if (res.data.success === false) {
          Swal.fire({
            position: "top-end",
            icon: "warning",
            title: res.data.data,
            showConfirmButton: false,
            timer: 2500
          })
        } else {
          Swal.fire({
            position: "top-end",
            icon: "success",
            title: res.data.data,
            showConfirmButton: false,
            timer: 1500
          })
        }

        this.carregarDados()
      })



      // console.log('then axios boleto')
      // console.log(res)
      // this.updating = false
      // Swal.fire({
      //   position: "top-end",
      //   icon: "success",
      //   title: "Consulta realizada com sucesso!",
      //   text: "Status atual do boleto: " + res.data[0]['resultado']['situacaoBoleto'],
      //   showConfirmButton: false,
      //   timer: 3500
      // })

    },

    segundaViaBoleto() {
      console.log('segundaViaBoleto')
      this.updating = true
      api.get(`${getBaseUrl()}api/fbolsvia`, {
        params: { iddata: this.idData }
      }).then((res) => {
        console.log('then axios boleto')
        console.log(res)

        const pdfBoleto = res.data[0].resultado.pdfBoleto

        const linkSource = `data:application/pdf;base64,${pdfBoleto}`;
        const downloadLink = document.createElement("a");
        const fileName = `boleto_lancto_${this.idData}.pdf`;
        downloadLink.href = linkSource;
        downloadLink.download = fileName;
        downloadLink.click()

        this.updating = false

      })

    },

    abrirEditarRecorrencia() {
      this.financeiroData.ocorrencia = "RECO"
      this.financeiroData.atributorecorrencia = "FINA"

      this.financeiroData.intervParcelasRecorrencia = this.financeiroData.intervParcelasRecorrencia ?? 30;
      this.showModalEditRecorrencia = true;
    },

    alterandoRecorrencia(financeiroData) {
      console.log('Alterando recorrência')

      this.submittedRecorr = true;

      if (this.reconfigreco === false) {
        if (!financeiroData.valor || financeiroData.valor <= 0) {
          return;
        }
      } else {
        console.log('reconfigurar recorrência TRUE')
        console.log(financeiroData)
        if (!financeiroData.valor ||
            (financeiroData.valor <= 0 &&
            !financeiroData.emissao &&
            !financeiroData.vencimento &&
            !financeiroData.qtdrecorrencia &&
            !financeiroData.intervParcelasRecorrencia &&
            !financeiroData.qtdparc &&
            !financeiroData.consutil &&
            !financeiroData.emissaofixa)
        ) {
          return;
        }
      }

      Swal.fire({
        position: "top",
        icon: "warning",
        title: "Alterando Registro",
        text: "Esta ação irá alterar todos os registros financeiro 'Em Aberto' deste fluxo de recorrência. Deseja confirmar esta ação?",
        confirmButtonText: "Confirmar",
        showCancelButton: true,
        showConfirmButton: true,
      }).then((result) => {
        if (result.isConfirmed) {
          console.log('Confirmou alteração!')
          api.post(`${getBaseUrl()}api/altrecorrencia`, {
            financeiroData: financeiroData,
            reconfigrecorr: this.reconfigreco

          }).then((res) => {
            console.log('then axios quitar recorrência')
            console.log(res.data)

            if (res.data.success === true) {
              Swal.fire({
                position: "top-end",
                icon: "success",
                title: res.data.data,
                showConfirmButton: false,
                timer: 2000
              })

              if (this.reconfigreco === true) {
                this.$router.replace({ path: `/creceber/editar/${res.data[0].id}` })
                this.idData = res.data[0].id
              }

              this.submittedRecorr = false
              this.showModalEditRecorrencia = false
              this.carregarDados()

            } else if (res.data.success === false) {
              Swal.fire({
                position: "top-end",
                icon: "error",
                title: res.data.data,
                showConfirmButton: false,
                timer: 2000
              })
            }
          })
        }
      })
    },

    quitandoRecorrencia(financeiroData) {
      console.log('Quitando recorrência')

      this.submittedRecorr = true;

      if (!financeiroData.valorqit || financeiroData.valorqit <= 0) {
        return;
      }

      Swal.fire({
        position: "top",
        icon: "warning",
        title: "Quitar Registro",
        text: "Esta ação irá quitar todos os registros financeiro 'Em Aberto' deste fluxo de recorrênciananceiro. Deseja confirmar esta ação?",
        confirmButtonText: "Confirmar",
        showCancelButton: true,
        showConfirmButton: true,
      }).then((result) => {
        if (result.isConfirmed) {
          console.log('Confirmou quitação!')
          api.post(`${getBaseUrl()}api/qitrecorrencia`, {
            financeiroData: financeiroData
          }).then((res) => {
            console.log('then axios quitar recorrência')
            console.log(res.data)

            if (res.data.success === true) {
              Swal.fire({
                position: "top-end",
                icon: "success",
                title: res.data.data,
                showConfirmButton: false,
                timer: 2000
              })

              this.submittedRecorr = false
              this.showModalEditRecorrencia = false
              this.carregarDados()

            } else if (res.data.success === false) {
              Swal.fire({
                position: "top-end",
                icon: "error",
                title: res.data.data,
                showConfirmButton: false,
                timer: 2000
              })
            }
          })
        }
      })
    },


    deletandoRecorrencia(idRecorr) {
      console.log('Deletando recorrência')

      Swal.fire({
        position: "top",
        icon: "warning",
        title: "Exclusão de Registro",
        text: "Esta ação irá deletar todos os registros financeiro 'Em Aberto' deste fluxo de recorrênciananceiro. Deseja confirmar esta ação?",
        confirmButtonText: "Confirmar",
        showCancelButton: true,
        showConfirmButton: true,
      }).then((result) => {
        if (result.isConfirmed) {
          // Confirmou
          console.log('Confirmou exclusão!')
          api.delete(`${getBaseUrl()}api/delrecorrencia`, {
            params: { numeroFinanceiro: idRecorr }
          }).then((res) => {
            console.log('then axios delete recorrência')
            console.log(res.data)

            if (res.data.success === true) {
              Swal.fire({
                position: "top-end",
                icon: "success",
                title: res.data.data,
                showConfirmButton: false,
                timer: 2000
              })

              this.submittedRecorr = false
              this.showModalEditRecorrencia = false
              router.push('/financeiros/contasreceberdetalhado');

            } else if (res.data.success === false) {
              Swal.fire({
                position: "top-end",
                icon: "error",
                title: res.data.data,
                showConfirmButton: false,
                timer: 2000
              })
            }

          })
        }
      })
    },


    novoPIX() {
      console.log('novoPIX')
      api.get(`${getBaseUrl()}api/finanpix`, {
        params: { iddata: this.idData }
      }).then((res) => {
        console.log('then axios pix')
        console.log(res.data)

      })

    },


    nomeStatus(strEntr) {
      let result = 'Não Definido'
      switch (strEntr) {
        case 'A':
          result = 'Em Aberto'
          break
        case 'P':
          result = 'Quitado Parcial'
          break
        case 'Q':
          result = 'Quitado'
          break
        case 'X':
          result = 'Cancelado'
          break
        case 'RE':
          result = 'Renegociado'
          break
        default:
          result = 'Não Definido'
          break
      }
      return result
    },


    redirectFinan(redirect_id){
      console.log('redirectFinan', redirect_id)
      const routeData = this.$router.resolve(`/creceber/editar/${redirect_id}`)
      window.open(routeData.href, '_blank')
    },

    nomeStatusParc(strEntr) {
      let result = 'Não Definido'
      switch (strEntr) {
        case 'AB':
          result = 'Em Aberto'
          break
        case 'AG':
          result = 'Agendado'
          break
        case 'QP':
          result = 'Quitado Parcial'
          break
        case 'QT':
          result = 'Quitado'
          break
        case 'CX':
          result = 'Cancelado'
          break
        case 'EL':
          result = 'Elaboração'
          break
        case 'RE':
          result = 'Renegociado'
          break
        default:
          result = 'Não Definido'
          break
      }
      return result
    },

    nomeFormapgtoParc(strEntr) {
      let result = "Não Definido";

      if (this.dtListPesqFormaPgto) {
        const item = this.dtListPesqFormaPgto.find(p => p.codigo === strEntr);
        if (item) {
          result = item.descricao;
        }
      }
      return result;
    },

    selecionaCondPgto() {
      console.log('selecionaCondPgto')

        this.showModalCondPgto = true
    },

    confirmarCondPgto() {
      console.log('confirmarCondPgto')

      this.financeiroData.intervParcCondPgto = this.condPgtoData.intervpers
      this.financeiroData.qtdparc = this.condPgtoData.parcelas

      this.showModalCondPgto = false
    },

    pesqConta(evt){
      console.log('pesqFinConta')
      console.log(evt)
      let query = evt
      if (query.length > 1){
        api.get(`${getBaseUrl()}api/ccontapesq`, {
          params: { q: query }
        }).then((res) => {
          console.log('then axios')
          console.log(res.data)
          this.dtListPesqConta = res.data
          this.dtListPesqConta.sort((a,b) => a.codigo - b.codigo);
        });
      }
    },

    pesqFormaPgto(evt) {
      console.log("pesqFormaPgto");
      // console.log(evt);
      let query = evt ?? '';
      this.loadingFormaPgto = true;
      this.financeiroData.formapgto = "";
      api.get(`${getBaseUrl()}api/fpgtopesq`, {
        params: { q: query },
      })
          .then((res) => {
            console.log("then axios");
            console.log(res.data);
            //console.log(res.data.length)
            this.dtListPesqFormaPgto = res.data;
            this.dtListPesqFormaPgto.sort((a,b) => a.id - b.id);
          });
    },

    pesqNatureza(evt) {
      console.log('pesqNatureza')
      console.log(evt)
      let query = evt
      // console.log(query.length)

        this.loadingNatureza = true
        this.financeiroData.natureza = ''
        api.get(`${getBaseUrl()}api/naturpesq`, {
          params: { q: query, t: 'E', f: this.financeiroData.empresa }
        }).then((res) => {
          console.log('then axios naturpesq')
          console.log(res.data)
          //console.log(res.data.length)
          this.dtlistPesqNatureza = res.data
          this.dtlistPesqNatureza.sort((a,b) => a.id - b.id);

          if (this.idData === 0 && this.naturezaData.descricao === 'Lançamento Avulso' && this.dtlistPesqNatureza.length > 0) {
            this.financeiroData.natureza = this.dtlistPesqNatureza[0].id
            this.naturezaData.id = this.dtlistPesqNatureza[0].id
            this.naturezaData.descricao = this.dtlistPesqNatureza[0].descricao
          }
        })
    },

    pesqCategoria(evt) {
      console.log('pesqCategoria')
      console.log(evt)
      let query = evt
      // console.log(query.length)
      if (query.length > 1) {
        this.loadingCategoria = true
        this.financeiroData.categoria = ''
        api.get(`${getBaseUrl()}api/pesqcateg`, {
          params: { q: query, t: this.financeiroData.tipo, f: this.financeiroData.empresa }
        }).then((res) => {
          console.log('then axios')
          console.log(res.data)
          //console.log(res.data.length)
          this.dtlistPesqCategoria = res.data
          this.dtlistPesqCategoria.sort((a,b) => a.id - b.id);
        })
      }
    },

    pesqCliente(evt) {
      console.log('pesqCliente')
      console.log(evt)
      let query = evt
      if (query.length > 1) {
        api.get(`${getBaseUrl()}api/clipesq`, {
          params: { q: query }
        }).then((res) => {
          console.log('then axios')
          console.log(res.data)
          this.dtListPesqCli = res.data
        });
      }
    },

    pesqFinConta(evt) {
      console.log('pesqFinConta')
      console.log(evt)
      let query = evt
      if (query.length > 1) {
        api.get(`${getBaseUrl()}api/fcontapesq`, {
          params: { q: query }
        }).then((res) => {
          console.log('then axios')
          console.log(res.data)
          this.dtListPesqFinConta = res.data
        });
      }
    },

    pesqCondPgto(evt) {
      console.log('pesqCondPgto')
      // console.log(evt)
      let query = evt ?? ''
      // console.log(query.length)

      this.loadingCondPgto = true
      api.get(`${getBaseUrl()}api/cpgtopesq`, {
        params: { q: query }
      }).then((res) => {
        console.log('then axios')
        console.log(res.data)
        this.dtListPesqCondPgto = res.data

        if(this.financeiroData.condpgto){
          this.escolheuCondPgto()
        }
      })

    },

    escolheuConta() {
      console.log('selectedContaData', this.financeiroData.banco_id)
      this.loadingConta = true;
      console.log(this.financeiroData.banco_id);
      api.get(`${getBaseUrl()}api/cconta`, {
        params: { iddata: this.financeiroData.banco_id },
      }).then((res) => {
        console.log("then axios");
        // console.log(res.data);
        this.ContaData = res.data[0];

        this.loadingConta = false;
        this.financeiroData.banco_id = this.ContaData.id;
        this.financeiroData.banco = this.ContaData.banco;
      });
    },

    escolheuFormaPgto() {
      console.log("escolheuFormaPgto");
      this.loadingFormaPgto = true;

      let formapgto = this.regSelFinParc.formapgto ?? this.financeiroData.formapgto

      api.get(`${getBaseUrl()}api/fpgtocod`, {
        params: { coddata: formapgto },
      })
          .then((res) => {
            console.log("then axios FormaPgto");
            console.log(res.data);
            this.formaPgtoData = res.data[0];

            this.loadingFormaPgto = false;
            this.regSelFinParc.formapgto = this.formaPgtoData.codigo
            this.regSelFinParc.codpgtoid = this.formaPgtoData.codpgtoid
          });
    },

    escolheuNatureza(){
      console.log('escolheuNatureza')

      if(Array.isArray(this.dtlistPesqNatureza) && this.dtlistPesqNatureza.length > 0) {
        this.naturezaData = this.dtlistPesqNatureza.find((natureza) => {
          if (natureza.id === this.financeiroData.natureza){
            console.log('natureza selected:')
            console.log(natureza)

            return natureza
          } else if (natureza.descricao === this.financeiroData.natureza){
            console.log('natureza selected:')
            console.log(natureza)

            return natureza
          }
        })

        this.loadingNatureza = false
        this.financeiroData.natureza = this.naturezaData.id
      }
    },

    escolheuCategoria(){
      console.log('escolheuCategoria')

      if(Array.isArray(this.dtlistPesqCategoria) && this.dtlistPesqCategoria.length > 0) {
        this.categoriaData = this.dtlistPesqCategoria.find((categoria) => {
          if (categoria.id === this.financeiroData.categoria){
            console.log('categoria selected:')
            console.log(categoria)

            return categoria
          }
        })

        this.loadingCategoria = false
        this.financeiroData.categoria = this.categoriaData.id
      }
    },

    escolheuCli() {
      console.log('escolheuCli')
      this.loadingCliente = true
      console.log(this.financeiroData.pessoa)
      api.get(`${getBaseUrl()}api/clicod`, {
        params: { coddata: this.financeiroData.pessoa }
      }).then((res) => {
        console.log('then axios')
        console.log(res.data)
        this.clienteData = res.data[0]

        this.loadingCliente = false
      })
    },

    escolheuFinConta() {
      console.log('escolheuFinConta')
      console.log(this.financeiroData.conta)
      api.get(`${getBaseUrl()}api/fconta`, {
        params: { coddata: this.financeiroData.conta }
      }).then((res) => {
        console.log('then axios')
        console.log(res.data)
        this.finContaData = res.data[0]

      })
    },

    escolheuCondPgto() {
      console.log('escolheuCondPgto')
      this.loadingCondPgto = true
      // console.log(this.financeiroData.condpgto)
      api.get(`${getBaseUrl()}api/cpgtocod`, {
        params: { coddata: this.financeiroData.condpgto }
      }).then((res) => {
        console.log('then axios')
        console.log(res.data)
        this.condPgtoData = res.data[0]
        this.ultPedsData = res.data[1]

        this.financeiroData.intervParcCondPgto = this.condPgtoData.intervpers ?? this.condPgtoData.interv
        this.financeiroData.qtdparc = this.condPgtoData.parcelas

        let totalPed = 0
        this.ultPedsData.forEach((value) => {
          totalPed += value.valorliq
        });

        this.somaPedidosCli = totalPed
        this.loadingCondPgto = false
      })
    },

    carregarParcelas() {
      this.loadingParcelas = true
      api.get(`${getBaseUrl()}api/finanparcs`, {
        params: { iddata: this.idData }
      }).then((res) => {
        console.log('then axios')
        console.log(res.data)
        this.finanParcsData = res.data[0]
        this.loadingParcelas = false
      });
    },

    abrirModalPagBank(finanparcId) {
      this.pagbankFinanparcId = finanparcId
      this.pagbankSoftdescriptor = ''
      this.pagbankQtdparcelas = 1
      this.pagbankQtdparcelassemjuros = 0
      this.pagbankLinkGerado = null
      this.showModalPagBank = true
    },

    async gerarLinkPagBank() {
      if (!this.pagbankSoftdescriptor) {
        Swal.fire({ icon: 'warning', title: 'Campo obrigatório', text: 'O campo Texto na fatura é obrigatório.' })
        return
      }

      if (this.pagbankQtdparcelassemjuros === 1) {
        Swal.fire({ icon: 'warning', title: 'Valor inválido', text: 'A quantidade de parcelas sem juros deve ser 0 ou maior que 1.' })
        return
      }

      this.pagbankLoading = true
      this.pagbankLinkGerado = null
      try {
        const res = await api.post(`${getBaseUrl()}api/pagbank/gerar-link-pagamento`, {
          finanparc_id: this.pagbankFinanparcId,
          softdescriptor: this.pagbankSoftdescriptor,
          qtdparcelas: this.pagbankQtdparcelas,
          qtdparcelassemjuros: this.pagbankQtdparcelassemjuros,
        })
        if (res.data && res.data.linkpgto) {
          this.pagbankLinkGerado = res.data.linkpgto
        } else {
          Swal.fire({ icon: 'error', title: 'Erro', text: res.data?.error || 'Não foi possível gerar o link.' })
        }
      } catch (err) {
        const msg = err.response?.data?.error || 'Erro ao comunicar com o servidor.'
        Swal.fire({ icon: 'error', title: 'Erro', text: msg })
      } finally {
        this.pagbankLoading = false
      }
    },

    copiarLinkPagBank() {
      if (this.pagbankLinkGerado) {
        navigator.clipboard.writeText(this.pagbankLinkGerado)
        Swal.fire({ icon: 'success', title: 'Copiado!', text: 'Link copiado para a área de transferência.', timer: 1500, showConfirmButton: false })
      }
    },

    async abrirVerLinkPagBank(finanparcId) {
      this.pagbankVerLinkLoading = true
      try {
        const res = await api.get(`${getBaseUrl()}api/pagbank/link-pagamento`, {
          params: { finanparc_id: finanparcId }
        })
        if (res.data && res.data.linkpgto) {
          this.pagbankFinanparcId = finanparcId
          this.pagbankLinkGerado = res.data.linkpgto
          this.showModalPagBank = true
        } else {
          Swal.fire({ icon: 'error', title: 'Erro', text: 'Link não encontrado.' })
        }
      } catch (err) {
        Swal.fire({ icon: 'error', title: 'Erro', text: err.response?.data?.error || 'Erro ao buscar o link.' })
      } finally {
        this.pagbankVerLinkLoading = false
      }
    },

    inativarLinkPagBank(finanparcId) {
      Swal.fire({
        icon: 'warning',
        title: 'Cancelar link de pagamento',
        text: 'Isso irá inativar o checkout na PagBank e remover o link. Deseja continuar?',
        confirmButtonText: 'Confirmar',
        cancelButtonText: 'Cancelar',
        showCancelButton: true,
      }).then(async result => {
        if (!result.value) return
        this.pagbankInativarLoading = true
        try {
          await api.post(`${getBaseUrl()}api/pagbank/inativar-link-pagamento`, {
            finanparc_id: finanparcId
          })
          Swal.fire({ icon: 'success', title: 'Inativado!', text: 'Link de pagamento cancelado com sucesso.', timer: 2000, showConfirmButton: false })
          this.carregarDados()
        } catch (err) {
          Swal.fire({ icon: 'error', title: 'Erro', text: err.response?.data?.error || 'Erro ao inativar o link.' })
        } finally {
          this.pagbankInativarLoading = false
        }
      })
    },

    deletaBoleto(iditem) {
      console.log('deletaBoleto')
      console.log(iditem)

      Swal.fire({
        position: "center",
        icon: "question",
        title: "Exclusão de Registro",
        text: "Esta operação é irreversível, tem certeza que deseja continuar?",
        confirmButtonText: "Confirmar",
        cancelButtonText: "Cancelar",
        showCancelButton: true,
        showConfirmButton: true,

      }).then(result => {
        if (result.value) {
          this.loadingParcelas = true

          api.delete(`${getBaseUrl()}api/delboleto`, {
            params: {
              'iddata': iditem
            }
          }).then((res) => {
            console.log('then axios delete')
            console.log(res.data)

            if (res.data.success === false) {
              Swal.fire({
                position: "top-end",
                icon: "warning",
                title: res.data.data,
                showConfirmButton: false,
                timer: 2500
              })
            } else {
              Swal.fire({
                position: "top-end",
                icon: "success",
                title: "Informações excluídas com sucesso!",
                showConfirmButton: false,
                timer: 1500
              })
            }

            this.carregarDados()
          })

        }
      })

    },

    deletarParcela(iditem) {
      console.log('deletarParcela')
      console.log(iditem)

      if (this.finanParcsData.length === 1) {

        Swal.fire({
          position: "top",
          icon: "warning",
          title: "Exclusão de Registro",
          text: "Esta parcela é única neste registro financeiro, deseja excluir apenas a parcela ou todo o registro financeiro?",
          confirmButtonText: "Excluir apenas Parcela",
          denyButtonText: "Excluir Financeiro",
          showDenyButton: true,
          showConfirmButton: true,
        }).then((result) => {
          if (result.isConfirmed) {
            // Excluir apenas Parcela
            const deletaParceFin = false
            this.deletarParceFin(iditem, deletaParceFin)
          } else if (result.isDenied) {
            // Excluir Financeiro
            const deletaParceFin = true
            this.deletarParceFin(iditem, deletaParceFin)
          }
        })

      } else {
        const deletaParceFin = false
        this.deletarParceFin(iditem, deletaParceFin)
      }
    },

    deletarParceFin(iditem, deletaParceFin) {
      console.log('escolheu deletaParceFin')
      console.log(iditem, deletaParceFin)

      let textTitle = deletaParceFin === false ? "Exclusão do Registro desta Parcela." : "Exclusão deste Registro Financeiro."

      Swal.fire({
        position: "center",
        icon: "question",
        title: textTitle,
        text: "Esta operação é irreversível, tem certeza que deseja continuar?",
        confirmButtonText: "Confirmar",
        cancelButtonText: "Cancelar",
        showCancelButton: true,
        showConfirmButton: true,

      }).then(result => {
        if (result.value) {
          this.loadingParcelas = true

          api.delete(`${getBaseUrl()}api/finanparc`, {
            params: {
              'iddata': iditem,
              'deletaparcefin': deletaParceFin
            }
          }).then((res) => {
            console.log('then axios delete')
            console.log(res.data)

            this.finanParcsData = res.data[0]
            this.loadingParcelas = false

            if (res.data[0] === 'sucesso' && res.data[2]) {
              Swal.fire({
                position: "top-end",
                icon: "success",
                title: res.data[1],
                showConfirmButton: false,
                timer: 1500
              }).then(() => {
                this.finanParcsData = res.data[2]
                this.carregarDados()
              })
            } else if (res.data[0] === 'sucesso') {
              Swal.fire({
                position: "top-end",
                icon: "success",
                title: res.data[1],
                showConfirmButton: false,
                timer: 1500
              })

              if (deletaParceFin === true) {
                router.push('/financeiros/contasreceberdetalhado');
              } else if (deletaParceFin === false) {
                this.carregarDados()
              }

            } else if (res.data[0] === 'erro') {
              Swal.fire({
                position: "top-end",
                icon: "success",
                title: res.data[1],
                showConfirmButton: false,
                timer: 1500
              })
              this.carregarDados()
            }
          })
        }
      })
    },

    editarParcela(dataParcela) {
      console.log('editarParcela: ')
      // console.log(dataParcela)
      this.showModalFinanParc = true
      this.regSelFinParc = dataParcela

      if(this.dtListPesqFormaPgto && this.regSelFinParc.formapgto){
        const item = this.dtListPesqFormaPgto.find(p => p.codigo === this.regSelFinParc.formapgto)
        this.formaPgtoData = [
          {
            id: item.id,
            codigo: item.codigo,
            descricao: item.descricao,
          }
        ]
      }
      // console.log('dtListPesqFormaPgto: ' , this.dtListPesqFormaPgto);
    },


    novaParcela() {
      console.log('novaParcela')


      if (this.financeiroData.status === 'EL') {

        Swal.fire({
          position: "top-end",
          icon: "warning",
          title: "Status em Elaboração não pode ser manipulado, favor confirmar movimento relacionado antes.",
          showConfirmButton: false,
          timer: 3000
        })

      } else {

        let possuiBaixa = false
        this.finanParcsData.forEach((value) => {
          if (value.status === 'QT') {
            possuiBaixa = true
          }
        })

        if (possuiBaixa) {

          Swal.fire({
            position: "top-end",
            icon: "warning",
            title: "Favor cancelar as baixas efetivadas neste lançamento para novo parcelamento",
            showConfirmButton: false,
            timer: 3000
          })


        } else {
          if (this.idData === 0) {

            Swal.fire({
              position: "top-end",
              icon: "warning",
              title: "Favor salvar o lançamento antes de adicionar parcela",
              showConfirmButton: false,
              timer: 1500
            })

          } else {
            this.finanparcData = {
              // destinoform: ['AC','MG'],
              // cfop: ['5102']
            }
            this.submitFinanParc = false
            this.financeiroData.consutil = false
            this.showModalParcela = true
          }
        }




      }

    },

    renegociar() {
      console.log("renegociar");

      if (this.financeiroData.status === "QT") {
        Swal.fire({
          position: "top-end",
          icon: "warning",
          title: "Status quitado não pode ser manipulado!",
          showConfirmButton: false,
          timer: 3000,
        });
      } else {
        if (this.idData === 0) {
          Swal.fire({
            position: "top-end",
            icon: "warning",
            title: "Favor salvar o lançamento antes de renegociar",
            showConfirmButton: false,
            timer: 1500,
          });
        } else {
          this.isRenegotiating = true;

          // Calcular valor remanescente
          let paidSum = 0;
          this.finanParcsData.forEach((value) => {
            if (value.status === "QT" || value.status === "QP") {
              paidSum += parseFloat(value.valor);
            }
          });
          this.financeiroData.valor =
            ((parseFloat(this.financeiroData.valorori) || 0) - paidSum).toFixed(2);

          this.finanparcData = {};
          this.submitFinanParc = false;
          this.financeiroData.consutil = false;
          this.financeiroData.qtdparc = 1;
          this.showModalParcela = true;
        }
      }
    },

    confirmarNovoParcelamento() {
      console.log('confirmarNovoParcelamento:')

      this.financeiroData.ocorrencia = "COND"
      this.submitFinanParc = true

      if (!this.financeiroData.valor || this.financeiroData.valor <= 0) {
        Swal.fire({
          position: "top-end",
          icon: "warning",
          title: "Favor inserir valor antes de confirmar",
          showConfirmButton: false,
          timer: 1500
        })
      } else if (!this.financeiroData.condpgto && this.financeiroData.formatorenegociacao === false) {
        Swal.fire({
          position: "top-end",
          icon: "warning",
          title:"Favor selecionar a condição de pagamento antes de confirmar",
          showConfirmButton: false,
          timer: 1500
        })
      } else if (!this.financeiroData.primeiro_vencimento && this.financeiroData.formatorenegociacao === true) {
        Swal.fire({
          position: "top-end",
          icon: "warning",
          title:"Favor selecionar o primeiro vencimento antes de confirmar",
          showConfirmButton: false,
          timer: 1500
        })
      } else if (!this.financeiroData.qtdparc || this.financeiroData.qtdparc <= 0 && this.financeiroData.formatorenegociacao === true) {
        Swal.fire({
          position: "top-end",
          icon: "warning",
          title:"A quantidade de parcelas deve ser maior que zero",
          showConfirmButton: false,
          timer: 1500
        })
      } else if (!this.financeiroData.emissao) {
        Swal.fire({
          position: "top-end",
          icon: "warning",
          title: "Favor selecionar data de emissão antes de confirmar",
          showConfirmButton: false,
          timer: 1500
        })
      } else {
        if (this.qtdParcelas) {
          this.showModalParcela = false
          this.loadingParcelas = true
          console.log('formSubmit_validado')

          this.financeiroData.ocorrencia =  this.financeiroData.formatorenegociacao === true ? 'MANUAL' : 'COND';

          const successMsg = this.isRenegotiating
            ? "Renegociação realizada com sucesso!"
            : "Parcelamento criado com sucesso!";

          const endpoint = this.isRenegotiating
            ? `${getBaseUrl()}api/finanrenegociar`
            : `${getBaseUrl()}api/finannovparc`;

          api.post(endpoint, {
            financData: this.financeiroData
          }).then((res) => {
            console.log('then axios')
            console.log(res.data)

            this.isRenegotiating = false;

            if (res.data.error) {
              Swal.fire({
                position: "top-end",
                icon: "error",
                title: "Operação não foi concluída com sucesso!",
                showConfirmButton: false,
                timer: 1500
              })
            }

            Swal.fire({
              position: "top-end",
              icon: "success",
              title: successMsg,
              showConfirmButton: false,
              timer: 1500
            })

            if (res.data.operacao === 'renegociar') {
              console.log('redirecting to new creceber')
              this.$router.replace({ path: `/creceber/editar/${res.data.financeiro_id}` })
            }

            this.atualizaPagina()


          }).catch((err) => {
            this.isRenegotiating = false;
            console.log('erro axios')
            // console.log(err)
            // console.log(err.response)
            // console.log(err.response.data.errors)
            let erros = err.response.data.errors
            console.log(erros)
            console.log(typeof erros)
            let listaErros = []
            Object.keys(erros).forEach(key => {
              console.log(key, erros[key]);
              listaErros.push({
                'titulo': key,
                'mensagem': erros[key]
              })
            });
            this.errosValid = listaErros
            this.updating = false
          })
        }
      }

    },


    salvar() {
      // if (this.financeiroData.status === 'EL') {
      //   Swal.fire({
      //     position: "top-end",
      //     icon: "warning",
      //     title: "Status em Elaboração não pode ser manipulado, favor confirmar movimento relacionado antes.",
      //     showConfirmButton: false,
      //     timer: 3000
      //   })
      // } else {

      if(this.financeiroData.ocorrencia === 'RECO' && this.financeiroData.qtdrecorrencia < 1) {
        Swal.fire({
          position: "top-end",
          icon: "warning",
          title:
              "Recorrência exige no mínimo 1 recorrência",
          showConfirmButton: false,
          timer: 3000,
        })
      } else {

        this.submitted = true
        this.submitFinanc = true
        this.v$.$touch()
        console.log('salvarFinanc')

        if(!this.financeiroData.pessoa){
          Swal.fire({
            position: "top-end",
            icon: "warning",
            title: this.v$.financeiroData.pessoa.required.$message,
            showConfirmButton: false,
            timer: 1500
          })
        } else if (!this.financeiroData.numero) {
          Swal.fire({
            position: "top-end",
            icon: "warning",
            title: this.v$.financeiroData.numero.required.$message,
            showConfirmButton: false,
            timer: 1500
          })
        } else if (!this.financeiroData.valor || this.financeiroData.valor <= 0) {
          Swal.fire({
            position: "top-end",
            icon: "warning",
            title: this.v$.financeiroData.valor.required.$message,
            showConfirmButton: false,
            timer: 1500
          })
        } else if (!this.financeiroData.natureza) {
          Swal.fire({
            position: "top-end",
            icon: "warning",
            title: this.v$.financeiroData.natureza.required.$message,
            showConfirmButton: false,
            timer: 1500
          })
        } else if (!this.financeiroData.formapgto ) {
          Swal.fire({
            position: "top-end",
            icon: "warning",
            title: this.v$.financeiroData.formapgto.required.$message,
            showConfirmButton: false,
            timer: 1500
          })
        } else if (!this.financeiroData.categoria ) {
          Swal.fire({
            position: "top-end",
            icon: "warning",
            title: this.v$.financeiroData.categoria.required.$message,
            showConfirmButton: false,
            timer: 1500
          })
        } else if (!this.financeiroData.banco_id) {
          Swal.fire({
            position: "top-end",
            icon: "warning",
            title: this.v$.financeiroData.banco_id.required.$message,
            showConfirmButton: false,
            timer: 1500
          })
        } else {
          console.log('salvarFinanc_00')

          this.errosValid = []
          this.salvarRequest();
        }
      }
    },

    salvarRequest() {
      console.log('salvarRequest')
      // console.log(this.financeiroData)

      api.post(`${getBaseUrl()}api/financeironv`, {
        financeiroData: this.financeiroData
      }).then((res) => {
        console.log('then axios')
        console.log(res)

        if (res.data.error) {
          Swal.fire({
            position: 'top-end',
            icon: 'error',
            text: 'Operançao não pode ser finalizada, verifique as informações.',
            showCancelButton: false,
            showConfirmButton: false,
            timer: 4000
          })
        } else {
          this.submitted = false
          this.v$.$reset()
          Swal.fire({
            position: "top-end",
            icon: "success",
            title: "Informação salva com sucesso",
            showConfirmButton: false,
            timer: 1500
          })

          if (this.idData === 0) {
            console.log('redirecionar')
            this.$router.replace({ path: `/creceber/editar/${res.data[0].id}` })
            this.idData = res.data[0].id
            this.carregarDados()

            this.updating = false
          } else {
            this.carregarDados()
          }
        }
      }).catch((err) => {
        console.log('erro axios')
        // console.log(err)
        // console.log(err.response)
        // console.log(err.response.data.errors)
        let erros = err.response.data.errors
        console.log(erros)
        console.log(typeof erros)
        let listaErros = []
        Object.keys(erros).forEach(key => {
          console.log(key, erros[key]);
          listaErros.push({
            'titulo': key,
            'mensagem': erros[key]
          })
        });
        this.errosValid = listaErros
        this.updating = false
      });
    },


    onChangeVencimentoFixo(val) {
      if (val) {
        this.financeiroData.ocorrencia = 'RECO'
      }
    },

    onChangeOcorrencia() {
      if (this.financeiroData.ocorrencia === 'COND' || this.financeiroData.ocorrencia === 'MANUAL') {
        this.financeiroData.vencimentofixo = false
      }
    },

    formatDecimal(value) {
      // return parseFloat(value).toFixed(2)
      // console.log('format_value')
      // console.log(value)
      // console.log(typeof value)
      if (value) {
        let value_n = parseFloat(value).toFixed(2)
        return Number(value_n).toLocaleString('pt-BR', { style: 'decimal', minimumFractionDigits: 2 })
      }
      return "0,00"
    },

    formatDate(value) {
      // console.log('value formatDate')
      // console.log(value)
      // console.log(moment())
      const format = "DD/MM/YYYY"
      var date = new Date(value);
      let dateTime = moment(date).format(format);
      // console.log(dateTime1)
      return dateTime
    },

  },
  mounted() {
    console.log('mounted_contareceber_editar_00')
    let rota = this.$route.path
    // console.log(rota)
    let ultimaBarra = rota.lastIndexOf('/')
    if (ultimaBarra) {
      this.idData = parseInt(rota.substring(ultimaBarra + 1))
    }
    console.log(`idData: ${this.idData}`)

    this.carregarDados()

  }
};
</script>

<template>
  <Layout>
    <PageHeader :title="title" :items="items" />

    <b-alert v-for="(erro, i) in errosValid" :key="`alerta-${i}`" show dismissible variant="danger">
      <i class="mdi mdi-alert me-2"></i>Pendente validação de campo: {{ erro.titulo }} -- {{ erro.mensagem[0] }} --
      favor ajustar e tentar novamente.
    </b-alert>

    <Loader v-if="updating" style="min-height: 400px;">
    </Loader>


    <div class="row" v-if="!updating">

      <div class="col-lg-12">
        <div class="card">
          <div class="card-body">
            <div class="d-flex align-items-start">


              <b-button variant="outline-primary" class="mx-2" @click="salvar">
                <i class="bx bx-save font-size-16 align-middle me-2"></i>
                Salvar Alterações
              </b-button>

              <b-button variant="outline-warning" class="mx-2" @click="novaParcela">
                <i class="bx bx-plus-circle font-size-16 align-middle me-2"></i>
                Novo Parcelamento
              </b-button>

              <b-button v-if="idData > 0" variant="outline-secondary" class="mx-2" @click="renegociar">
                <i class="bx bx-poll font-size-16 align-middle me-2"></i>
                Renegociar
              </b-button>

              <b-button variant="outline-info" class="mx-2" v-if="idData > 0" @click="novoAnexo">
                <i class="bx bx-upload font-size-16 align-middle me-2"></i>
                Anexar Arquivo
              </b-button>

              <b-button variant="outline-danger" class="mx-2" @click="excluirLancto">
                <i class="bx bx-block font-size-16 align-middle me-2"></i>
                Excluir
              </b-button>

              <b-button variant="outline-info" class="mx-2" v-if="idData > 0" @click="novoPIX" :disabled="true">
                <i class="bx bx-money font-size-16 align-middle me-2"></i>
                PIX
              </b-button>

              <b-button variant="outline-danger" class="mx-2" v-if="idData > 0" @click="gerarCaixa">
                <i class="bx bx-download font-size-16 align-middle me-2"></i>
                Gerar Caixa
              </b-button>

              <b-button v-if="idData > 0" variant="outline-warning" class="mx-2" @click="abrirEditarRecorrencia">
                <i class="bx bx-edit font-size-16 align-middle me-2"></i>
                Editar Recorrência
              </b-button>

              <div class="flex-grow-1 align-self-center">
                <div class="text-muted">

                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

    </div>

    <div class="checkout-tabs" v-if="!updating">

      <b-card-text>
        <div class="card">
          <div class="card-body">
            <form class="needs-validation">
              <div class="row">



                <div class="col-md-4">
                  <div class="mb-3">
                    <div class="mb-2">
                      <span class="text-black font-18 ">Fornecedor</span>
                    </div>

                    <multiselect id="inputCliente" @search-change="pesqCliente" @select="escolheuCli"
                      v-model="financeiroData.pessoa" placeholder="Pesquisar fornecedor" :options="dtListPesqCli"
                      :searchable="true" label="nome" class="multiselect-size" track-by="nome"
                      :style="submitFinanc && !financeiroData.pessoa ? 'border: 1px solid #f86c6b !important;' : ''"
                      value-prop="codigo">
                      <template #option="slotProps">
                        <div class="row">
                          <div>

                            <span class="text-info">
                              {{ slotProps.option.codigo }}
                            </span>
                            <span class="mx-4">
                              {{ slotProps.option.cnpj }}
                            </span>
                          </div>
                          <div class="mt-2 font-size-16">{{ slotProps.option.nome }}</div>
                          <div class="align-items-end text-end align-content-end">{{ slotProps.option.cidade }} - {{
                            slotProps.option.estado }}</div>
                        </div>
                      </template>
                    </multiselect>
                    <div v-if="submitFinanc && !financeiroData.pessoa">
                      <span class="text-danger font-size-11">Campo Fornecedor obrigatório, favor preencher.</span>
                    </div>


                  </div>

                </div>



                <div class="col-md-4">
                  <div class="mb-3">
                    <div class="mb-2">
                      <span class="text-black font-18 ">Tipo de Operação</span>
                    </div>
                    <input
                      id="tipoOperacao"
                      type="text"
                      class="form-control"
                      value="Receitas"
                      disabled
                    />
                  </div>

                </div>

                <div class="col-md-2">
                  <div class="mb-3">
                    <label for="numero">Número</label>
                    <input
                        id="numero"
                        v-model="financeiroData.numero"
                        type="text"
                        class="form-control"
                        placeholder="Número do documento"
                        :class="{
                        'is-invalid':
                          submitted && v$.financeiroData.numero.$error,
                      }"
                    />
                    <div
                        v-if="submitted && v$.financeiroData.numero.$error"
                        class="invalid-feedback">
                      <span v-if="v$.financeiroData.numero.required.$message">
                        {{ v$.financeiroData.numero.required.$message }}
                      </span>
                    </div>
                  </div>
                </div>

                <div class="col-md-2">
                  <div class="mb-3">
                    <label for="codigo">Código</label>
                    <input
                        id="codigo"
                        v-model="financeiroData.codigo"
                        type="text"
                        class="form-control"
                        placeholder="Código do documento"
                    />
                  </div>
                </div>

                <div class="col-md-2">
                  <div class="mb-3">
                    <label
                        for="valor"
                        class="text-end align-content-end align-items-end"
                    >Valor Final</label
                    >
                    <input
                        id="valor"
                        v-model="financeiroData.valor"
                        type="number"
                        class="form-control text-end"
                        placeholder="Valor do documento"
                        :readonly="idData > 0"
                        :class="{
                        'is-invalid':
                          submitted && v$.financeiroData.valor.$error,
                      }"
                    />
                    <div
                        v-if="submitted && v$.financeiroData.valor.$error"
                        class="invalid-feedback"
                    >
                      <span v-if="v$.financeiroData.valor.required.$message">{{
                          v$.financeiroData.valor.required.$message
                        }}</span>
                    </div>
                  </div>
                </div>

                <div class="col-md-2">
                  <div class="mb-3">
                    <label
                        for="valorori"
                        class="text-end align-content-end align-items-end"
                    >Valor Original</label
                    >
                    <input
                        id="valorori"
                        v-model="financeiroData.valorori"
                        type="number"
                        class="form-control text-end"
                        disabled
                        placeholder="Valor original do documento"
                    />
                  </div>
                </div>

                <div class="col-md-2">
                  <div class="mb-3">
                    <label
                        for="valorabe"
                        class="text-end align-content-end align-items-end"
                    >Valor Aberto</label
                    >
                    <input
                        id="valorabe"
                        v-model="financeiroData.valorabe"
                        type="number"
                        class="form-control text-end"
                        disabled
                        placeholder="Valor em aberto"
                    />
                  </div>
                </div>

                <div class="col-md-2">
                  <div class="mb-3">
                    <label
                        for="valorqit"
                        class="text-end align-content-end align-items-end"
                    >Valor Quitado</label
                    >
                    <input
                        id="valorqit"
                        v-model="financeiroData.valorqit"
                        type="number"
                        class="form-control text-end"
                        disabled
                        placeholder="Valor quitado"
                    />
                  </div>
                </div>

                <div class="col-md-2">
                  <div class="mb-3">
                    <label
                        for="valoracresc"
                        class="text-end align-content-end align-items-end"
                    >Juros</label
                    >
                    <input
                        id="valoracresc"
                        v-model="financeiroData.valoracresc"
                        type="number"
                        class="form-control text-end"
                        disabled
                        placeholder="Valor desconto"
                    />
                  </div>
                </div>

                <div class="col-md-2">
                  <div class="mb-3">
                    <label
                        for="valordesc"
                        class="text-end align-content-end align-items-end"
                    >Descontos</label
                    >
                    <input
                        id="valordesc"
                        v-model="financeiroData.valordesc"
                        type="number"
                        class="form-control text-end"
                        disabled
                        placeholder="Valor desconto"
                    />
                  </div>
                </div>

                <div class="col-md-2">
                  <div class="mb-3">
                    <div class="d-flex align-items-start">
                      <label for="emissao" class="me-3">Emissão</label>
                      <b-form-checkbox
                          v-if="idData === 0"
                          switch
                          v-model="financeiroData.emissaofixa"
                          title="Emissão Fixa/Flexível"
                      >
                        <span class="font-size-12">{{ financeiroData.emissaofixa ? 'Fixa' : 'Flexível' }}</span>
                      </b-form-checkbox>
                    </div>
                    <input
                        id="emissao"
                        v-model="financeiroData.emissao"
                        type="date"
                        class="form-control"
                        placeholder="Data de emissão"
                        :class="{'is-invalid':submitted && v$.financeiroData.emissao.$error,}"/>
                    <div v-if="submitted && v$.financeiroData.emissao.$error" class="invalid-feedback">
                      <span v-if="v$.financeiroData.emissao.required.$message">
                        {{ v$.financeiroData.emissao.required.$message }}
                      </span>
                    </div>
                  </div>
                </div>

                <div class="col-md-2">
                  <div class="mb-3">
                    <div class="d-flex align-items-start">
                      <label for="primeiro_vencimento" class="me-3">1º Vencimento</label>
                      <b-form-checkbox
                          v-if="idData === 0"
                          switch
                          v-model="financeiroData.vencimentofixo"
                          @change="onChangeVencimentoFixo"
                          :disabled="financeiroData.ocorrencia === 'MANUAL'"
                          title="Vencimento Fixo/Flexível">
                        <span class="font-size-12">{{ financeiroData.vencimentofixo ? 'Fixo' : 'Flexível' }}</span>
                      </b-form-checkbox>
                    </div>

                    <input
                      id="primeiro_vencimento"
                      v-model="financeiroData.primeiro_vencimento"
                      type="date"
                      class="form-control"
                      placeholder="Data do primeiro vencimento"
                      :disabled="(!financeiroData.vencimentofixo && financeiroData.ocorrencia !== 'MANUAL')"
                    />
                  </div>
                </div>

                <div class="col-md-2">
                  <div class="mb-3">
                    <label for="vencimento">Ult. Vencimento</label>
                    <input
                      id="vencimento"
                      v-model="financeiroData.vencimento"
                      type="date"
                      readonly
                      class="form-control"
                      disabled
                      placeholder="Data de vencimento"
                    />
                  </div>
                </div>

                <div class="col-md-2">
                  <div class="mb-3">
                    <label for="compet">Competência</label>
                    <input
                        id="compet"
                        v-model="financeiroData.compet"
                        type="date"
                        readonly
                        class="form-control"
                        placeholder="Data de competência"
                    />
                  </div>
                </div>

                <div class="col-md-2">
                  <div class="mb-3">
                    <label for="dtbaixa">Dt. Quitação</label>
                    <input
                        id="dtbaixa"
                        v-model="financeiroData.dtbaixa"
                        type="date"
                        readonly
                        class="form-control"
                        placeholder="Data de competência"/>
                  </div>
                </div>

                <div class="col-sm-2">
                  <div class="mb-3">
                    <label for="sttquitacao">Status Quitação</label>
                    <b-form-checkbox
                        switch size="lg"
                        checked-value="QT"
                        unchecked-value="N"
                        disabled
                        v-model="financeiroData.stsbaixa">
                      {{ financeiroData.stsbaixa === 'QT' ? 'Quitado' : 'Em Aberto' }}
                    </b-form-checkbox>
                  </div>
                </div>

                <div class="col-md-2">
                  <div class="mb-3">
                    <label for="natureza">Natureza da Operação</label>
                    <multiselect id="natureza"
                                 @search-change="pesqNatureza"
                                 @select="escolheuNatureza"
                                 v-model="financeiroData.natureza"
                                 placeholder="Pesquisar Natureza da operação"
                                 :options="dtlistPesqNatureza"
                                 :searchable="true"
                                 label="descricao"
                                 :class="{'is-invalid':submitted && v$.financeiroData.natureza.$error,}"
                                 class="multiselect-size"
                                 track-by="id"
                                 value-prop="id">
                      <template #option="slotProps">
                        <div class="row">
                          <div>
                            <span class="">
                              {{ slotProps.option.id }}
                            </span>
                            <span class="ms-2" >
                              {{ slotProps.option.descricao }}
                            </span>
                          </div>
                        </div>
                      </template>
                    </multiselect>
                    <div v-if="submitted && v$.financeiroData.natureza.$error" class="invalid-feedback">
                      <span v-if="v$.financeiroData.natureza.required.$message">
                        {{ v$.financeiroData.natureza.required.$message }}
                      </span>
                    </div>
                    <span class="text-warning" v-if="!financeiroData.natureza && !submitted && (financeiroData.tabela && financeiroData.origem_id)">Campo Obrigatório</span>
                  </div>
                </div>

                <div class="col-md-2">
                  <div class="mb-3">
                    <label for="formapgto">Forma de Pagamento</label>
                    <multiselect id="formapgto"
                                 @select="escolheuFormaPgto"
                                 v-model="financeiroData.formapgto"
                                 placeholder="Pesquisar forma de pagamento"
                                 :options="dtListPesqFormaPgto"
                                 :searchable="false"
                                 label="descricao"
                                 :disabled="idData > 0"
                                 :class="{'is-invalid':submitted && v$.financeiroData.formapgto.$error,}"
                                 class="multiselect-size"
                                 track-by="codigo"
                                 value-prop="codigo">
                      <template #option="slotProps">
                        <div class="row">
                          <div>
                          <span class="">
                            {{ slotProps.option.codigo }}
                          </span>
                            <span class="ms-2" >
                            {{ slotProps.option.descricao }}
                          </span>
                          </div>
                        </div>
                      </template>
                    </multiselect>
                    <div v-if="submitted && v$.financeiroData.formapgto.$error" class="invalid-feedback">
                      <span v-if="v$.financeiroData.formapgto.required.$message">
                        {{ v$.financeiroData.formapgto.required.$message }}
                      </span>
                    </div>
                    <span class="text-warning" v-if="!financeiroData.formapgto && !submitted">Campo Obrigatório</span>
                  </div>
                </div>

                <div class="col-md-2">
                  <div class="mb-3">
                    <label for="categoria">Categoria da Operação</label>
                    <multiselect id="categoria"
                                 @search-change="pesqCategoria"
                                 @select="escolheuCategoria"
                                 v-model="financeiroData.categoria"
                                 placeholder="Pesquisar Categoria da Operação"
                                 :options="dtlistPesqCategoria"
                                 :searchable="true"
                                 label="descricao"
                                 :class="{'is-invalid':submitted && v$.financeiroData.categoria.$error,}"
                                 class="multiselect-size"
                                 track-by="id"
                                 value-prop="id">
                      <template #option="slotProps">
                        <div class="row">
                          <div>
                            <span class="">
                              {{ slotProps.option.id }}
                            </span>
                            <span class="ms-2" >
                              {{ slotProps.option.descricao }}
                            </span>
                          </div>
                        </div>
                      </template>
                    </multiselect>
                    <div v-if="submitted && v$.financeiroData.categoria.$error" class="invalid-feedback">
                      <span v-if="v$.financeiroData.categoria.required.$message">
                        {{ v$.financeiroData.categoria.required.$message }}
                      </span>
                    </div>
                    <span class="text-warning" v-if="!financeiroData.categoria && !submitted">Campo Obrigatório</span>
                  </div>
                </div>

                <div class="col-md-2">
                  <div class="mb-3">
                    <label for="banco">Instituição bancária</label>
                    <multiselect id="inputFinConta"
                                 @search-change="pesqConta"
                                 @select="escolheuConta"
                                 v-model="financeiroData.banco_id"
                                 placeholder="Selecione a Inst. Bancária"
                                 :options="dtListPesqConta"
                                 :searchable="true"
                                 label="descricao"
                                 :class="{'is-invalid':submitted && v$.financeiroData.banco_id.$error,}"
                                 class="multiselect-size"
                                 track-by="descricao"
                                 value-prop="id">
                      <template #option="slotProps">
                        <div class="row">
                          <div>
                            <span class="">
                              {{ slotProps.option.id }}
                            </span>
                            <span class="font-size-10 mx-1 me-4">
                               (banco: {{ slotProps.option.banco }})
                            </span>
                            <span class="" >
                              {{ slotProps.option.descricao }}
                            </span>
                          </div>
                        </div>
                      </template>
                    </multiselect>
                    <div v-if="submitted && v$.financeiroData.banco_id.$error" class="invalid-feedback">
                      <span v-if="v$.financeiroData.banco_id.required.$message">
                        {{ v$.financeiroData.banco_id.required.$message }}
                      </span>
                    </div>
                    <span class="text-warning" v-if="!financeiroData.banco_id && !submitted">Campo Obrigatório</span>
                  </div>
                </div>
              </div>

              <div class="row">
                <div class="col-md-12">
                  <div class="mb-3">
                    <label for="obsc">Histórico</label>
                    <textarea
                      id="obsc"
                      v-model="financeiroData.obs"
                      type="text"
                      rows="3"
                      class="form-control"
                      placeholder="Histórico do documento" />
                  </div>
                </div>
              </div>

              <div v-if="idData === 0" class="d-flex justify-content-start col-12">
                <div class="mb-3 col-md-2 me-4">
                  <div>
                    <label for="ocorrencia">Tipo de Recorrência</label>
                    <select 
                      id="ocorrencia"
                      v-model="financeiroData.ocorrencia"
                      @change="onChangeOcorrencia"
                      class="form-control">
                      <option value="COND">Cond. de Pagamento</option>
                      <option value="MANUAL">Config. Manual</option>
                      <option value="RECO">Recorrente</option>
                    </select>
                  </div>
                </div>

                <div class="d-flex justify-content-start col-md-10 me-4">

                  <div v-if="financeiroData.ocorrencia === 'COND'" class="mb-3 col-md-2 me-4 position-relative">
                    <label for="condpgto" class="text-end align-content-end align-items-end" title="Condição de Pagamento">
                      <a href="#" @click.stop.prevent="selecionaCondPgto">
                        Cond. de Pagamento
                        <i class="bx bx-customize font-size-15 align-middle" />
                      </a>
                    </label>

                    <multiselect id="condpgto"
                                 @search-change="pesqCondPgto"
                                 @select="escolheuCondPgto"
                                 v-model="financeiroData.condpgto"
                                 placeholder="Selecione Cond. de Pagamento"
                                 :options="dtListPesqCondPgto"
                                 :searchable="true"
                                 label="descricao"
                                 track-by="descricao"
                                 value-prop="codigo">
                      <template #option="slotProps">
                        <div class="row">
                          <div>
                            <span class="text-info "> {{ slotProps.option.codigo }} </span>
                            <span class="mx-2 font-size-20"> {{ slotProps.option.descricao }} </span>
                          </div>
                          <div class="align-items-end text-end align-content-end font-size-12">
                            {{ formatDate(slotProps.option.created_at) }}
                          </div>
                        </div>
                      </template>
                    </multiselect>
                  </div>

                  <div v-if="financeiroData.ocorrencia === 'RECO'" class="mb-3 col-md-2">
                    <label for="atributorecorrencia" class="text-end align-content-end align-items-end"
                      title="Indicar onde a recorrência será aplicada">Incidência</label>
                    <select id="atributorecorrencia" v-model="financeiroData.atributorecorrencia" readonly
                      class="form-control">
                      <option value="FINA">Financeiro</option>
                      <!--                      <option value="PARC">Parcelas</option>-->
                    </select>
                  </div>

                  <div v-if="financeiroData.ocorrencia === 'RECO'" class="mb-3 col-md-2 mx-4">
                    <label for="qtdrecorrencia" class="text-end align-content-end align-items-end">Qtd.
                      recorrência</label>
                    <input id="qtdrecorrencia" v-model="financeiroData.qtdrecorrencia" type="number"
                      class="form-control text-end" placeholder="Quantidade" min="0"
                      :class="{ 'is-invalid': submitted && v$.financeiroData.qtdrecorrencia.$error, }" />
                    <div v-if="submitted && v$.financeiroData.qtdrecorrencia.$error" class="invalid-feedback">
                      <span v-if="v$.financeiroData.qtdrecorrencia.required.$message">{{
                        v$.financeiroData.qtdrecorrencia.required.$message }}</span>
                    </div>
                  </div>

                  <div class="mb-3 col-md-1 me-2">
                    <label for="qtdparcelas" class="text-end align-content-end align-items-end">
                      Qtd. parcelas
                    </label>
                    <input
                        id="qtdparcelas"
                        v-model.number="financeiroData.qtdparc"
                        type="number"
                        min="1"
                        class="form-control text-end"
                        placeholder="Quant. de Parcelas"
                        :disabled="financeiroData.ocorrencia === 'COND'"
                        :class="{ 'is-invalid': submitted && v$.$errors.length > 0 }"
                    />
                    <div v-if="submitted && v$.qtdparc?.$error" class="invalid-feedback">
                      <span v-if="v$.qtdparc?.required?.$invalid">
                        {{ v$.qtdparc.required.$message }}
                      </span>
                    </div>
                  </div>

                  <div v-if="financeiroData.ocorrencia === 'COND'" class="mb-3 col-md-2 me-4">
                    <label for="intervParcCondPgto" class="text-end align-content-start">
                      Intervalo (dias)
                    </label>
                    <input id="intervParcCondPgto" v-model="financeiroData.intervParcCondPgto"
                      class="form-control text-end" min="1" disabled placeholder="Interv. Parcela (dias)" />
                  </div>

                  <div v-if="financeiroData.ocorrencia !== 'COND'" class="mb-3 col-md-2 me-4">
                    <label 
                      for="intervParcelasRecorrencia" 
                      class="text-end align-content-start">
                      Intervalo (dias)
                    </label>
                    <input 
                      id="intervParcelasRecorrencia" 
                      v-model="financeiroData.intervParcelasRecorrencia"
                      type="number" 
                      class="form-control text-end" 
                      min="1" 
                      placeholder="Intervalo Parcela (dias)"
                      :disabled="financeiroData.vencimentofixo || (financeiroData.ocorrencia === 'MANUAL' && financeiroData.qtdparc <= 1)"
                      :class="{ 'is-invalid': submitted && v$.financeiroData.intervParcelasRecorrencia.$error, }" />
                    <div v-if="submitted && v$.financeiroData.intervParcelasRecorrencia.$error"
                      class="invalid-feedback">
                      <span v-if="v$.financeiroData.intervParcelasRecorrencia.required.$message">
                        {{ v$.financeiroData.intervParcelasRecorrencia.required.$message }}
                      </span>
                    </div>
                  </div>

                  <div v-if="financeiroData.ocorrencia !== 'COND'" class="mb-3 align-items-end align-content-start float-start ms-4">
                    <h5 class="font-size-14">Considerar Dt. Emissão</h5>
                    <b-form-checkbox 
                      switch 
                      v-model="financeiroData.emissaofixa" 
                      title="Dt. Emissão Fixa/Flexível"
                      >
                      {{ financeiroData.emissaofixa === false ? 'Flexível' : 'Fixa' }}
                    </b-form-checkbox>
                  </div>

                  <div v-if="financeiroData.ocorrencia === 'RECO'" class="mb-3 align-items-end align-content-start float-start ms-4">
                    <h5 class="font-size-14">Considerar Dt. Vencimento</h5>
                    <b-form-checkbox
                          switch
                          v-model="financeiroData.vencimentofixo"
                          title="Dt. Emissão Fixa/Flexível"
                        >
                          <span class="font-size-12">{{ financeiroData.vencimentofixo ? 'Fixo' : 'Flexível' }}</span>
                    </b-form-checkbox>
                  </div>

                  <div class="mb-3 align-items-end align-content-start float-start mx-4">
                    <h5 class="font-size-14">Considerar apenas dias úteis</h5>
                    <b-form-checkbox 
                      switch 
                      v-model="financeiroData.consutil"
                      title="Considerar apenas dias úteis"
                      >
                      {{ financeiroData.consutil === false ? 'Desativado' : 'Ativado' }}
                    </b-form-checkbox>
                  </div>
                </div>
              </div>
            </form>
          </div>
        </div>
      </b-card-text>

      <b-card-text>
        <div class="card">
          <div class="card-body">
            <div class="card shadow-none border mb-0">
              <div class="card-body">
                <h4 class="card-title mb-4">Parcelas do Lançamento Financeiro</h4>

                <!--                <p class="card-title-desc text-danger" v-if="this.parcVerifica !== 0" >
                  O valor total de Fatura ( {{ formatDecimal(financeiroData.valor) }} )
                  é diferente da soma das parcelas ( {{ formatDecimal(vlrTotalParcs) }} )
                </p>-->

                <div class="row" v-if="loadingParcelas">
                  <div class="col-12 text-center">
                    <b-spinner type="grow" class="m-6 mx-2" variant="secondary" role="status">
                    </b-spinner>
                    <b-spinner type="grow" class="m-6 mx-2" variant="secondary" role="status">
                    </b-spinner>
                    <b-spinner type="grow" class="m-6 mx-2" variant="secondary" role="status">
                    </b-spinner>
                  </div>
                </div>

                <div class="table-responsive" v-if="!loadingParcelas">
                  <table class="table align-middle mb-0 table-nowrap">
                    <thead class="table-light">
                      <tr>
                        <th scope="col">ID</th>
                        <th scope="col">Número</th>
                        <th scope="col">Seq.</th>
                        <th scope="col">Obs</th>
                        <th scope="col">Extrato Assoc.</th>
                        <th scope="col">Forma de Pgto</th>
                        <th scope="col">Emissão</th>
                        <th scope="col">Vencimento</th>
                        <th scope="col">Baixa</th>
                        <th scope="col">Status</th>
                        <th scope="col" class="text-end">Valor</th>
                        <th scope="col" class="text-end">Juros</th>
                        <th scope="col" class="text-end">Desconto</th>
                        <th scope="col" class="text-end">Vlr. Total</th>
                        <th scope="col" class="text-end">Vlr. Quitado</th>
                        <th scope="col" class="text-center">Ações</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr v-for="data in finanParcsData" :key="data.id">

                        <td>
                          <h5 class="font-size-14 text-truncate">
                            <span class="text-dark">
                              {{ data.id }}
                            </span>
                          </h5>
                        </td>
                        <td>
                          <h5 class="font-size-14 text-truncate">
                            <span class="text-dark">
                              {{ data.numero }}
                            </span>
                          </h5>
                        </td>
                        <td>
                          <h5 class="font-size-14 text-truncate">
                            <span class="text-dark">
                              {{ data.sequencial }}
                            </span>
                          </h5>
                        </td>
                        <td style="max-width:400px; white-space: normal;">
                          <div v-if="data.sttvenc">
                            {{ data.sttvenc }}
                          </div>

                          <div>
                            {{ data.obs }}
                          </div>
                        </td>
                        <td :title="'Clique no X para desassociar extrato'">
                          <span
                              class="badge badge-pill badge-soft-success font-size-11"
                              :class="data.extrato_id ? 'badge-soft-success' : 'badge-soft-warnig'"
                          >
                            {{ data.extrato_id ? 'Id Assoc.: ' + data.extrato_id : ''}}
                          </span>
                          <i v-if="data.extrato_id" style="cursor:pointer" class="bx bx-x font-size-20 align-middle text-danger" @click="desassociarExtrato(data)"></i>
                        </td>
                        <td style="max-width: 50px; white-space: normal">
                          <h5 class="font-size-14">
                            <span class="text-dark">
                              {{ nomeFormapgtoParc(data.formapgto) }}
                            </span>
                          </h5>
                        </td>
                        <td>{{ data.emissao_fmt }}</td>
                        <td>{{ data.vencimento_fmt }}</td>
                        <td>{{ data.dtbaixa_fmt }}</td>
                        <td>
                          <span class="badge badge-pill badge-soft-success font-size-11"
                            :class="data.status === 'QT' ? 'badge-soft-success' :
                              data.status === 'AB' ? 'badge-soft-danger' : data.status === 'CX' ? 'badge-soft-danger' : 'badge-soft-warning'">
                            {{ nomeStatusParc(data.status) }}
                          </span>
                        </td>

                        <td class="text-end">
                          <h5 class="font-size-14 text-truncate">
                            <span class="text-dark">
                              {{ formatDecimal(data.valor) }}
                            </span>
                          </h5>
                        </td>

                        <td class="text-end">
                          <h5 class="font-size-14 text-truncate">
                            <span class="text-dark">
                              {{ formatDecimal(data.juros) }}
                            </span>
                          </h5>
                        </td>

                        <td class="text-end">
                          <h5 class="font-size-14 text-truncate">
                            <span class="text-dark">
                              {{ formatDecimal(data.desconto) }}
                            </span>
                          </h5>
                        </td>

                        <td class="text-end">
                          <h5 class="font-size-14 text-truncate">
                            <span class="text-dark">
                              {{ formatDecimal(data.vlrtotalparc) }}
                            </span>
                          </h5>
                        </td>

                        <td class="text-end">
                          <h5 class="font-size-14 text-truncate">
                            <span class="text-dark">
                              {{ formatDecimal(data.valorqit) }}
                            </span>
                          </h5>
                        </td>

                        <td class="text-center">
                          <div class="button-items">

                            <b-button variant="outline-warning" @click="editarParcela(data)"
                              v-if="data.status === 'AB'">
                              <i class="mdi mdi-pencil d-block font-size-16"></i>
                            </b-button>

                            <b-button
                              v-if="data.status === 'AB' && data.codpgtoid === 1 && !data.boleto_id"
                              variant="outline-info" @click="novoBoleto(data)" title="Gerar novo Boleto">
                              <i class="mdi mdi-file d-block font-size-16"></i>
                            </b-button>

                            <b-button variant="outline-secondary" @click="deletaBoleto(data.id)"
                              v-if="data.status === 'AB' && data.codpgtoid === 1 && data.boleto_id"
                              title="Deletar Boleto">
                              <i class="mdi mdi-file-remove d-block font-size-16"></i>
                            </b-button>

                            <!-- Gerar link: só quando não tem boleto_id -->
                            <b-button
                              v-if="data.codpgtoid == 4 && data.status === 'AB' && !data.boleto_id"
                              variant="warning"
                              @click="abrirModalPagBank(data.id)"
                              title="Gerar link de pagamento PagBank">
                              <i class="mdi mdi-credit-card-outline d-block font-size-16"></i>
                            </b-button>

                            <!-- Ver link existente -->
                            <b-button
                              v-if="data.codpgtoid == 4 && data.status === 'AB' && data.boleto_id"
                              variant="info"
                              @click="abrirVerLinkPagBank(data.id)"
                              title="Ver link de pagamento PagBank">
                              <i class="mdi mdi-link-variant d-block font-size-16"></i>
                            </b-button>

                            <!-- Inativar checkout -->
                            <b-button
                              v-if="data.codpgtoid == 4 && data.status === 'AB' && data.boleto_id"
                              variant="danger"
                              @click="inativarLinkPagBank(data.id)"
                              title="Cancelar link de pagamento PagBank">
                              <i class="mdi mdi-link-variant-off d-block font-size-16"></i>
                            </b-button>
                            
                            <b-button v-if="data.status === 'AB' && data.codpgtoid === 1 && data.boleto_id"
                              variant="outline-info" @click="segundavia(data)" title="2via Boleto">
                              <i class="mdi mdi-printer d-block font-size-16"></i>
                            </b-button>

                            <b-button variant="outline-warning" @click="consultarBoleto(data.id)"
                              v-if="data.status === 'AB' && data.codpgtoid === 1" title="Consultar Boleto">
                              <i class="mdi mdi-file-search d-block font-size-16"></i>
                            </b-button>

                            <b-button variant="outline-danger" @click="deletarParcela(data.id)"
                              v-if="data.status === 'AB'" title="Deletar Parcela">
                              <i class="mdi mdi-trash-can d-block font-size-16"></i>
                            </b-button>

                            <b-button variant="outline-success" @click="baixarParcela(data)" v-if="data.status === 'AB'"
                              title="Quitar Parcela">
                              <i class="mdi mdi-credit-card-check d-block font-size-16"></i>
                            </b-button>

                            <b-button variant="outline-warning" @click="cancBaixarParcela(data)"
                              v-if="data.status === 'QT'" title="Cancelar Quitação de Parcela">
                              <i class="mdi mdi-credit-card-minus d-block font-size-16"></i>
                            </b-button>

                            <b-button variant="outline-success" @click="baixarArquivoCnabParcela(data)"
                              v-if="data.status === 'AB' && data.codpgtoid === 1"
                              title="Baixar Cnab">
                              <i class="mdi mdi-file-document d-block font-size-16"></i>
                            </b-button>


                          </div>
                        </td>

                      </tr>

                    </tbody>
                  </table>
                </div>



              </div>
            </div>
          </div>
        </div>

      </b-card-text>


      <!--      Histórico de baixa de parcelas-->
      <b-card-text>
        <div class="card">
          <div class="card-body">
            <div class="card shadow-none border mb-0">
              <div class="card-body">
                <h4 class="card-title mb-4">Histórico Financeiro - Baixas(R${{ formatDecimal(totalCaixaData) }})</h4>
                <div class="row" v-if="loadingParcelas">
                  <div class="col-12 text-center">
                    <b-spinner type="grow" class="m-6 mx-2" variant="secondary" role="status">
                    </b-spinner>
                    <b-spinner type="grow" class="m-6 mx-2" variant="secondary" role="status">
                    </b-spinner>
                    <b-spinner type="grow" class="m-6 mx-2" variant="secondary" role="status">
                    </b-spinner>
                  </div>
                </div>

                <div class="table-responsive" v-if="!loadingParcelas">
                  <table class="table align-middle mb-0 table-nowrap">
                    <thead class="table-light">
                      <tr>
                        <th scope="col">ID</th>
                        <th scope="col">Código</th>
                        <th scope="col">Tipo</th>
                        <th scope="col">Status</th>
                        <th scope="col">Data</th>
                        <th scope="col">Valor(R$)</th>
                      </tr>
                    </thead>
                    <tbody>


                      <tr v-for="data in finanCaixaData" :key="data.id">
                        <td>
                          <h5 class="font-size-14 text-truncate">
                            <span class="text-dark">
                              {{ data.id }}
                            </span>
                          </h5>
                        </td>
                        <td>
                          <h5 class="font-size-14 text-truncate">
                            <span class="text-dark">
                              {{ data.codigo }}
                            </span>
                          </h5>
                        </td>
                        <td>
                          <h5 class="font-size-14 text-truncate">
                            <span class="text-dark">
                              {{ data.tipo }}
                            </span>
                          </h5>
                        </td>
                        <td>{{ data.status }}</td>
                        <td>{{ formatDate(data.created_at) }}</td>
                        <td class="text-start">
                          <h5 class="font-size-14 text-truncate">
                            <span class="text-dark">
                              {{ formatDecimal(data.valor) }}
                            </span>
                          </h5>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </div>
        </div>

      </b-card-text>

      <!--      Histórico de Renegociação-->
      <b-card-text v-if="renegociacoesData && renegociacoesData.length > 0">
        <div class="card">
          <div class="card-body">
            <div class="card shadow-none border mb-0">
              <div class="card-body">
                <h4 class="card-title mb-4">
                  Histórico de Renegociação
                </h4>

                <div class="table-responsive">
                  <table class="table align-middle mb-0 table-nowrap">
                    <thead class="table-light">
                      <tr>
                        <th scope="col">ID</th>
                        <th scope="col">Data</th>
                        <th scope="col">Valor(R$)</th>
                        <th scope="col">Status</th>
                        <th scope="col">Ações</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr v-for="reneg in renegociacoesData" :key="reneg.id">
                        <td>
                          <span class="text-dark">{{ reneg.id }}</span>
                        </td>
                        <td>{{ formatDate(reneg.created_at) }}</td>
                        <td>{{ formatDecimal(reneg.valor) }}</td>
                        <td>
                          <span class="badge badge-pill badge-soft-success font-size-11"
                            :class="reneg.stsbaixa === 'QT' ? 'badge-soft-success' :
                              reneg.stsbaixa === 'AB' ? 'badge-soft-danger' : reneg.stsbaixa === 'CX' ? 'badge-soft-danger' : 'badge-soft-warning'">
                            {{ nomeStatusParc(reneg.stsbaixa) }}
                          </span>
                        </td>
                        <td>
                          <b-button variant="outline-info" size="sm" @click="redirectFinan(reneg.id)">
                            <i class="mdi mdi-eye"></i> Visualizar
                          </b-button>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </div>
        </div>
      </b-card-text>

      <b-card-text>
        <div class="card">
          <div class="card-body">

            <b-card no-body class="mb-1 shadow-none">
              <b-card-header header-tag="header" role="tab">
                <h6 class="m-0">
                  <a v-b-toggle.accordion-12 class="text-dark" href="javascript: void(0);">Anexos do Movimento</a>
                </h6>
              </b-card-header>
              <b-collapse id="accordion-12" visible accordion="my-accordion-12" role="tabpanel">
                <b-card-body>

                  <div class="card-body">
                    <!--                    <h4 class="card-title">Pasta de Anexos</h4>-->
                    <!--                    <p class="card-title-desc">-->
                    <!--                      Pasta de Anexos do Cliente</p>-->

                    <div class="row" v-if="loadingFiles">
                      <div class="col-12 text-center">
                        <b-spinner type="grow" class="m-6 mx-2" variant="secondary" role="status">
                        </b-spinner>
                        <b-spinner type="grow" class="m-6 mx-2" variant="secondary" role="status">
                        </b-spinner>
                        <b-spinner type="grow" class="m-6 mx-2" variant="secondary" role="status">
                        </b-spinner>
                      </div>
                    </div>



                    <div class="table-responsive" v-if="!loadingFiles">
                      <table class="table align-middle mb-0 table-nowrap">
                        <thead class="table-light">
                          <tr>
                            <th scope="col">ID</th>
                            <th scope="col">Descrição</th>
                            <th scope="col">Arquivo</th>
                            <th scope="col">Data</th>
                            <th scope="col">Ações</th>
                          </tr>
                        </thead>
                        <tbody>

                          <tr v-for="data in mediasData" :key="data.id">

                            <td>
                              <h5 class="font-size-14 text-truncate">
                                <span class="text-dark">
                                  {{ data.id }}
                                </span>
                              </h5>
                            </td>

                            <td>
                              {{ data.descricao }}
                            </td>

                            <td>
                              <span class="text-dark">
                                {{ data.nome }}
                              </span>
                            </td>

                            <td>
                              <h5 class="font-size-14 text-truncate">
                                <span class="text-dark">
                                  {{ formatDate(data.created_at) }}
                                </span>
                              </h5>
                            </td>


                            <td>
                              <div class="button-items">

                                <b-button variant="outline-success" @click="downFile(data.path, data.nome)">
                                  <i class="mdi mdi-download d-block font-size-16"></i>
                                </b-button>

                                <b-button variant="outline-danger" @click="delFile(data.id)"
                                  :disabled="data.email === 'admin@admin.com.br'">
                                  <i class="mdi mdi-trash-can d-block font-size-16"></i>
                                </b-button>

                              </div>
                            </td>


                          </tr>

                        </tbody>
                      </table>
                    </div>

                  </div>



                </b-card-body>
              </b-collapse>
            </b-card>

          </div>
        </div>
      </b-card-text>


    </div>


    <b-modal
        :title="finanparcData.id != null ? `Editar Parcelamento Financeiro (${finanparcData.id})` : 'Criar Novo Parcelamento'"
        v-model="showModalParcela" hide-footer>
        <div class="row">

          <div class=" d-flex col-12 mb-3 align-items-center align-content-center float-start">
            <div style="margin-top: -10px">
              <b-form-checkbox switch size="md" v-model="financeiroData.formatorenegociacao"/>
            </div>
            <h5 class="font-size-13">
              Config. nova parcela 
              <strong>{{financeiroData.formatorenegociacao === true ? 'Manualmente.' : 'por Cond. Pagamento.'}}</strong>
            </h5>
            
          </div>

          <div class="col-6">
            <div class="mb-3">
              <label for="valor">Valor</label>
              <input id="valor" v-model="financeiroData.valor" type="number" class="form-control"
                     placeholder="Inserir valor"/>
            </div>
          </div>


          <div class="col-6">
            <div class="mb-3">
              <label for="condpgto">Cond. de Pagamento</label>
              <multiselect id="condpgto" 
                @search-change="pesqCondPgto" 
                @select="escolheuCondPgto"
                v-model="financeiroData.condpgto"
                placeholder="Pesq. condição de pagamento"
                :disabled="financeiroData.formatorenegociacao === true"
                :options="dtListPesqCondPgto" 
                :searchable="true" 
                label="descricao" 
                track-by="descricao" 
                value-prop="codigo">
                <template #option="slotProps">
                  <div class="row">
                    <div>
                  <span class="text-info">
                    {{ slotProps.option.codigo }}
                  </span>
                      <span class="mx-4">
                  </span>
                    </div>
                    <div class="mt-2 font-size-20">{{ slotProps.option.descricao }}</div>
                    <span class="mx-4">
                </span>
                    <span class="mx-4">
                </span>
                    <div class="align-items-end text-end align-content-end">
                      {{ formatDate(slotProps.option.created_at) }}
                    </div>
                  </div>
                </template>
              </multiselect>

            </div>
          </div>

          <div class="col-6">
            <div class="mb-3">
              <label for="emissao">Data de Emissão</label>
              <input id="emissao" v-model="financeiroData.emissao" type="date" class="form-control"
                     placeholder="Data de Emissão" />
            </div>
          </div>

          <div class="col-6">
            <div class="mb-3">
              <label for="primeiro_vencimento">1º Vencimento</label>
              <input id="primeiro_vencimento" v-model="financeiroData.primeiro_vencimento" type="date" class="form-control"
                     :disabled="!financeiroData.formatorenegociacao"
                     placeholder="Data do primeiro vencimento" />
            </div>
          </div>

          <div class="col-6">
            <div class="mb-3">
              <label for="qtdparcelas">Qtd. parcelas</label>
              <input id="qtdparcelas" v-model="financeiroData.qtdparc" type="number" min="1" class="form-control"
                     :disabled="!financeiroData.formatorenegociacao"
                     placeholder="Quant. de Parcelas" />
            </div>
          </div>

          <div class="col-6">
            <div class="mb-3">
              <label for="intervalo">Intervalo de parcelas (dias)</label>
              <input id="intervalo" v-model="financeiroData.intervParcelasRecorrencia" type="number" min="1" class="form-control"
                     :disabled="!financeiroData.formatorenegociacao || financeiroData.qtdparc <= 1"
                     placeholder="Intervalo Parcela (dias)" />
            </div>
          </div>

          <div class="col-12">
            <div class="col-4 mb-3 align-items-end align-content-start float-start">
              <h5 class="font-size-13">Considerar emissão fixa</h5>
              <div style="margin-top: -10px">
                <b-form-checkbox switch size="lg" v-model="financeiroData.emissaofixa" >
                  {{ financeiroData.emissaofixa === false ? 'Flexível' : 'Fixa' }}
                </b-form-checkbox>
              </div>
            </div>

            <div class="col-4 mb-3 align-items-end align-content-start float-start">
              <h5 class="font-size-13">Considerar apenas dias úteis</h5>
              <div style="margin-top: -10px">
                <b-form-checkbox switch size="lg" v-model="financeiroData.consutil" >
                  {{ financeiroData.consutil === false ? 'Desativado' : 'Ativado' }}
                </b-form-checkbox>
              </div>
            </div>
          </div>

          <div class="col-12">
            <div class="mb-3">
              <label for="obs">Observações</label>
              <input id="obs" v-model="financeiroData.obs" type="text" class="form-control" placeholder="Observações" />
            </div>
          </div>

        </div>

        <div class="text-end mt-3">
          <b-button variant="light" @click="showModalParcela = false">
            <i class="bx bx-block font-size-16 align-middle me-2"></i>
            Fechar
          </b-button>
          <b-button variant="success" class="ms-1" @click="confirmarNovoParcelamento">
            <i class="bx bx-check-double font-size-16 align-middle me-2"></i>
            Confirmar
          </b-button>
        </div>

    </b-modal>


    <b-modal
      :title="regSelFinParc.id !== null ? `Editar Parcela Conta a Receber (${regSelFinParc.id})` : 'Criar Parcela Conta a Receber'"
      v-model="showModalFinanParc" hide-footer>
      <form @submit.prevent="formSubmitFinanParc">
        <div class="row">

          <div class="col-6">
            <div class="mb-3">
              <label for="numero">Número de documento</label>
              <input id="numero" v-model="regSelFinParc.numero" type="text" class="form-control"
                placeholder="Número de documento" />
            </div>
          </div>

          <div class="col-6">
            <div class="mb-3">
              <label for="valor">Valor</label>
              <input id="valor" v-model="regSelFinParc.valor" type="number" class="form-control"
                placeholder="Inserir valor" :class="{ 'is-invalid': submitFinanParc && !regSelFinParc.valor, }" />
              <div v-if="submitFinanParc && !regSelFinParc.valor" class="invalid-feedback">
                <span>Campo valor obrigatório, favor preencher.</span>
              </div>
            </div>
          </div>

          <div class="col-6">
            <div class="mb-3">
              <label for="desconto">Desconto</label>
              <input id="desconto" v-model="regSelFinParc.desconto" type="number" class="form-control"
                placeholder="Inserir Desconto" />
            </div>
          </div>

          <div class="col-6">
            <div class="mb-3">
              <div class="d-flex">
                <label for="juros">Juros</label>
                <div style="margin-left:10px">
                  <b-form-checkbox id="vlrtipo" switch size="md" value="vlr" unchecked-value="perc"
                    v-model="flagValorJuros">
                    {{ flagValorJuros === 'vlr' ? 'Vlr R$' : 'Perc %' }}
                  </b-form-checkbox>
                </div>
                <div style="margin-left:10px">
                  <b-form-checkbox id="tipojuros" switch size="md" value="dia" unchecked-value="mes" v-model="flagTipoJuros">
                    {{ flagTipoJuros === 'dia' ? 'ao dia' : 'ao mês' }}
                  </b-form-checkbox>
                </div>
              </div>
              <div>
                <input id="juros" v-model="regSelFinParc.juros" type="number" class="form-control col-12"
                  placeholder="Inserir Juros" />
              </div>
            </div>
          </div>

          <div class="col-6">
            <div class="mb-3">
              <label for="emissao">Data de Emissão</label>
              <input id="emissao" v-model="regSelFinParc.emissao" type="date" class="form-control"
                placeholder="Data de Emissão" />
            </div>
          </div>

          <div class="col-6">
            <div class="mb-3">
              <label for="vencimento">Data de Vencimento</label>
              <input id="vencimento" v-model="regSelFinParc.vencimento" type="date" class="form-control"
                placeholder="Data de Vencimento" />
            </div>
          </div>

          <div class="col-6">
            <div class="mb-3">
              <label for="formapgto">Forma de Pgto</label>
              <multiselect id="formapgto"
                           @select="escolheuFormaPgto"
                           v-model="regSelFinParc.formapgto"
                           placeholder="Pesquisar forma de pagamento"
                           :options="dtListPesqFormaPgto"
                           :searchable="false"
                           label="descricao"
                           class="multiselect-size"
                           track-by="codigo"
                           value-prop="codigo"> <!--:class="{'is-invalid':submitted && v$.financeiroData.formapgto.$error,}"-->
                <template #option="slotProps">
                  <div class="row">
                    <div>
                          <span class="">
                            {{ slotProps.option.codigo }}
                          </span>
                      <span class="ms-2" >
                            {{ slotProps.option.descricao }}
                          </span>
                    </div>
                  </div>
                </template>
              </multiselect>
            </div>
          </div>

          <div class="col-12">
            <div class="mb-3">
              <label for="obs">Observações</label>
              <input id="obs" v-model="regSelFinParc.obs" type="text" class="form-control" placeholder="Observações" />
            </div>
          </div>

        </div>

        <div class="text-end mt-3">
          <b-button variant="light" @click="showModalFinanParc = false">
            <i class="bx bx-block font-size-16 align-middle me-2"></i>
            Fechar
          </b-button>
          <b-button variant="success" class="ms-1" @click="formSubmitFinanParc">
            <i class="bx bx-check-double font-size-16 align-middle me-2"></i>
            Confirmar
          </b-button>
        </div>

      </form>

    </b-modal>

    <b-modal :title="`Editar Financeiro Recorrente`" v-model="showModalEditRecorrencia" hide-footer>

      <div class="row">

        <ul class="nav nav-tabs">
          <li class="nav-item" v-for="tab in tabs" :key="tab.name">
            <a class="nav-link" :class="{ active: currentTab === tab.name }" href="javascript:void(0);"
              @click="selectTab(tab.name)">
              {{ tab.label }}
            </a>
          </li>
        </ul>

        <div v-if="currentTab === 'alteraRecorrencia'">

          <div class="card-body">

            <div class="row">

              <div class="col-12 mb-3">
                <span class="text-warning"><strong>Warning! </strong> Esta função altera todos os registro "Em Aberto"
                  deste
                  fluxo recorrente.</span>
              </div>

              <div class="col-6">
                <div class="mb-3">
                  <label for="numero">Número de documento</label>
                  <input id="numero" v-model="financeiroData.numero" type="text" disabled class="form-control"
                    placeholder="Número de documento" />
                </div>
              </div>

              <div class="col-6">
                <div class="mb-3">
                  <label for="valor">Valor</label>
                  <input id="valor" v-model="financeiroData.valor" type="number" class="form-control"
                    placeholder="Inserir valor"
                    :class="{ 'is-invalid': submittedRecorr && (!financeiroData.valor || financeiroData.valor <= 0) }" />
                  <div v-if="submittedRecorr && (!financeiroData.valor || financeiroData.valor <= 0)"
                    class="invalid-feedback">
                    <span> Preenchimento obrigatório com valor maior que 0,00. </span>
                  </div>
                </div>
              </div>

              <div class="col-6">
                <div class="mb-3">
                  <label for="desconto">Desconto</label>
                  <input id="desconto" v-model="financeiroData.valordesc" type="text" class="form-control"
                    placeholder="Inserir Desconto" />
                </div>
              </div>

              <div class="col-6">
                <div class="mb-3">
                  <label for="juros">Juros</label>
                  <input id="juros" v-model="financeiroData.valoracresc" type="text" class="form-control"
                    placeholder="Inserir Juros" />
                </div>
              </div>

              <div class="col-4">
                <div class="mb-3">
                  <label for="emissao">Dt. Emissão</label>
                  <input
                    id="emissao"
                    v-model="financeiroData.emissao"
                    type="date"
                    disabled
                    class="form-control"
                    placeholder="Dt. Emissão"
                  />
                </div>
              </div>

              <div class="col-4">
                  <div class="mb-3">
                    <label for="primeiro_vencimento" class="me-3">1º Vencimento</label>
                    <input
                      id="primeiro_vencimento"
                      v-model="financeiroData.primeiro_vencimento"
                      type="date"
                      class="form-control"
                      placeholder="Data do primeiro vencimento"
                      disabled
                    />
                  </div>
                </div>

              <div class="col-4">
                <div class="mb-3">
                  <label for="vencimento">Ult. Vencimento</label>
                  <input
                    id="vencimento"
                    v-model="financeiroData.vencimento"
                    type="date"
                    disabled
                    class="form-control"
                    placeholder="Data de Vencimento"
                  />
                </div>
              </div>

              <div class="col-9">
                <div class="mb-3">
                  <label for="obs">Observações</label>
                  <input id="obs" v-model="financeiroData.obs" type="text" class="form-control"
                    placeholder="Observações" />

                </div>
              </div>

              <div class="mb-3 col-3 align-items-end align-content-start float-start">
                <label for="reconfigreco">reconfig. de recorrência</label>
                <div style="margin-top: -10px">
                  <b-form-checkbox id="reconfigreco" switch size="lg" v-model="reconfigreco">
                    {{ reconfigreco === false ? 'Não' : 'Sim' }}
                  </b-form-checkbox>
                </div>

              </div>

              <div v-if="reconfigreco === true">
                <div class="mt-1">
                  <h5>Nova Recorrência</h5>
                  <hr style="margin-top: -8px" />
                </div>

                <div class="row col-12">
                  <div class="col-6">
                    <div class="mb-3">
                      <label for="emissao">Nova Data de Emissão</label>
                      <input
                        id="emissao"
                        v-model="financeiroData.emissao"
                        type="date"
                        class="form-control"
                        placeholder="Data de Emissão"
                        :class="{ 'is-invalid': submittedRecorr && !financeiroData.emissao }"
                      />
                      <div v-if="submittedRecorr && !financeiroData.emissao" class="invalid-feedback">
                        <span> O preenchimento da emissão é obrigatório. </span>
                      </div>
                    </div>
                  </div>

                  <div class="col-6">
                    <div class="mb-3">
                      <label for="vencimento">Nova Data do 1º Vencimento</label>
                      <input
                        id="vencimento"
                        v-model="financeiroData.primeiro_vencimento"
                        type="date"
                        class="form-control"
                        :disabled="!financeiroData.vencimentofixo"
                        placeholder="Data de Vencimento"
                      />
                    </div>
                  </div>
                </div>

                <div class="d-flex justify-content-between col-12">
                  <div class="mb-3 col-3">
                    <label for="qtdrecorrencia" class="text-end align-content-end align-items-end">
                      Qtd. recorrência
                    </label>
                    <input id="qtdrecorrencia"
                        v-model="financeiroData.qtdrecorrencia"
                        type="number"
                        class="form-control text-end"
                        placeholder="Quantidade"
                        min="1"
                        :class="{'is-invalid':submittedRecorr && !financeiroData.qtdrecorrencia}"/>
                    <div v-if="submittedRecorr && !financeiroData.qtdrecorrencia" class="invalid-feedback">
                      <span> O preenchimento da quant. da recorrência é obrigatório. </span>
                    </div>
                  </div>

                  <div class="mb-3 col-3">
                    <label for="intervParcelasRecorrencia" class="text-end align-content-start">
                      Intervalo (dias)
                    </label>
                    <input id="intervParcelasRecorrencia"
                        v-model="financeiroData.intervParcelasRecorrencia"
                        type="number"
                        class="form-control text-end"
                        min="1"
                        :disabled="financeiroData.vencimentofixo"
                        placeholder="Intervalo Parcela (dias)"
                        :class="{'is-invalid':submittedRecorr &&!financeiroData.intervParcelasRecorrencia && !financeiroData.vencimentofixo}"/>
                    <div v-if="submittedRecorr && !financeiroData.intervParcelasRecorrencia && !financeiroData.vencimentofixo" class="invalid-feedback">
                      <span> O preenchimento do intervalo da recorrência é obrigatório. </span>
                    </div>
                  </div>

                  <div class="mb-3 col-3">
                    <label for="qtdparcelas" class="text-end align-content-end align-items-end">
                      Qtd. parcelas
                    </label>
                    <input id="qtdparcelas"
                        v-model="financeiroData.qtdparc"
                        type="number"
                        min="1"
                        class="form-control text-end"
                        placeholder="Quant. de Parcelas"
                        :class="{'is-invalid':submittedRecorr && !financeiroData.qtdparc,}"/>
                    <div v-if="submittedRecorr && !financeiroData.qtdparc" class="invalid-feedback">
                      <span> O preenchimento da quant. de parcelas é obrigatório. </span>
                    </div>
                  </div>
                </div>

                <div class="d-flex justify-content-between mb-3">
                  <div class="mb-3 align-items-end align-content-start float-start">
                    <h5 class="font-size-14">Considerar Dt. Emissão</h5>
                    <b-form-checkbox 
                      switch 
                      v-model="financeiroData.emissaofixa" 
                      title="Dt. Emissão Fixa/Flexível"
                    >
                      {{ financeiroData.emissaofixa === false ? 'Flexível' : 'Fixa' }}
                    </b-form-checkbox>
                  </div>
                

                  <div class="mb-3 align-items-end align-content-start float-start">
                    <h5 class="font-size-14">Considerar Dt. Vencimento</h5>
                    <b-form-checkbox
                          switch
                          v-model="financeiroData.vencimentofixo"
                          title="Dt. Emissão Fixa/Flexível"
                        >
                          <span class="font-size-12">{{ financeiroData.vencimentofixo ? 'Fixo' : 'Flexível' }}</span>
                    </b-form-checkbox>
                  </div>

                  <div class="mb-3 align-items-end align-content-start float-start">
                    <h5 class="font-size-14">Considerar apenas dias úteis</h5>
                    <b-form-checkbox 
                      switch 
                      v-model="financeiroData.consutil"
                      title="Considerar apenas dias úteis"
                      >
                      {{ financeiroData.consutil === false ? 'Desativado' : 'Ativado' }}
                    </b-form-checkbox>
                  </div>
                </div>
              </div>

            </div>

            <div class="text-end mt-2">
              <b-button variant="light" @click="showModalFinanParc = false">
                <i class="bx bx-block font-size-16 align-middle me-2"></i>
                Cancelar
              </b-button>
              <b-button variant="success" class="ms-2" @click="alterandoRecorrencia(financeiroData)">
                <i class="bx bx-check-double font-size-16 align-middle me-2"></i>
                Confirmar
              </b-button>
            </div>

          </div>
        </div>

        <div v-if="currentTab === 'quitaRecorrencia'">

          <div class="card-body">

            <div class="row">

              <div class="col-12 mb-4">
                <span class="text-success"><strong>Warning! </strong> Esta função quita todos os registro "Em Aberto"
                  deste
                  fluxo recorrente.</span>
              </div>

              <div class="col-6">
                <div class="mb-3">
                  <label for="numero">Número de documento</label>
                  <input id="numero" v-model="financeiroData.numero" type="text" disabled class="form-control"
                    placeholder="Número de documento" />
                </div>
              </div>

              <div class="col-6">
                <div class="mb-3">
                  <label for="valorqit">Valor Quitado</label>
                  <input id="valorqit" v-model="financeiroData.valorqit" type="number" class="form-control"
                    placeholder="Inserir valor"
                    :class="{ 'is-invalid': submittedRecorr && (!financeiroData.valorqit || financeiroData.valorqit <= 0) }" />
                  <div v-if="submittedRecorr && (!financeiroData.valorqit || financeiroData.valorqit <= 0)"
                    class="invalid-feedback">
                    <span> Preenchimento obrigatório com valor maior que 0,00. </span>
                  </div>
                </div>
              </div>

              <div class="col-6">
                <div class="mb-3">
                  <label for="vencimento">Data Vencimento</label>
                  <input id="vencimento" v-model="financeiroData.vencimento" type="date" disabled class="form-control"
                    placeholder="Data de Quitação" />
                </div>
              </div>

              <div class="col-6">
                <div class="mb-3">
                  <label for="recorrdtbaixa">Data de Quitação</label>
                  <input id="recorrdtbaixa" v-model="recorrdtbaixa" type="date" disabled class="form-control"
                    placeholder="Data de Quitação" />
                </div>
              </div>
            </div>

            <div class="text-end mt-3">
              <b-button variant="light" @click="showModalFinanParc = false">
                <i class="bx bx-block font-size-16 align-middle me-2"></i>
                Cancelar
              </b-button>
              <b-button variant="success" class="ms-2" @click="quitandoRecorrencia(financeiroData)">
                <i class="bx bx-money font-size-16 align-middle me-2"></i>
                Quitar
              </b-button>
            </div>
          </div>
        </div>

        <div v-if="currentTab === 'deletaRecorrencia'">
          <div class="card-body">

            <div class="row">

              <div class="col-12 mb-4">
                <span class="text-danger"><strong>Warning! </strong> Esta função deleta todos os registro "Em Aberto"
                  deste
                  fluxo recorrente.</span>
              </div>

              <div class="col-6">
                <div class="mb-3">
                  <label for="numero">Número de documento</label>
                  <input id="numero" v-model="financeiroData.numero" type="text" disabled class="form-control"
                    placeholder="Número de documento" />
                </div>
              </div>

              <div class="col-6">
                <div class="mb-3">
                  <label for="valor">Valor</label>
                  <input id="valor" v-model="financeiroData.valor" type="number" disabled class="form-control"
                    placeholder="Inserir valor" />
                </div>
              </div>

              <div class="col-6">
                <div class="mb-3">
                  <label for="emissao">Data Emissão</label>
                  <input id="emissao" v-model="financeiroData.emissao" type="date" disabled class="form-control"
                    placeholder="Data de Emissão" />
                </div>
              </div>

              <div class="col-6">
                <div class="mb-3">
                  <label for="recorrdtbaixa">Data de Baixa</label>
                  <input id="recorrdtbaixa" v-model="recorrdtbaixa" type="date" disabled class="form-control"
                    placeholder="Data de Vencimento" />
                </div>
              </div>
            </div>

            <div class="text-end mt-3">
              <b-button variant="light" @click="showModalFinanParc = false">
                <i class="bx bx-block font-size-16 align-middle me-2"></i>
                Cancelar
              </b-button>
              <b-button variant="danger" class="ms-2" @click="deletandoRecorrencia(financeiroData.numero)">
                <i class="bx bx-trash font-size-16 align-middle me-2"></i>
                Deletar
              </b-button>
            </div>
          </div>
        </div>
      </div>
    </b-modal>


    <b-modal :title="`Baixa de Parcela (${regSelFinParc.id})`" v-model="showModalBaixaParc" hide-footer>

      <div class="row">
        <div class="col-6">
          <div class="mb-3">
            <label for="valor">Valor</label>
            <input id="valor" v-model="baixaParcela.valor" type="number" class="form-control"
              placeholder="Inserir valor" />
          </div>
        </div>

        <div class="col-md-6">
          <div class="mb-3">
            <label for="databaixa">Data de Baixa</label>
            <input id="databaixa" v-model="baixaParcela.dtbaixa" type="date" class="form-control"
              placeholder="Deixar vazio para hoje" />
          </div>
        </div>

      </div>

      <div class="row">


        <div class="col-6">
          <div class="mb-3">
            <label for="caixa">Banco</label>
            <select id="caixa" v-model="baixaParcela.caixa" class="form-control">
              <option value="01">Caixa Banco</option>
              <option value="02">Caixa</option>
            </select>

          </div>
        </div>

      </div>

      <!--      <h5 class="card-title">Definições da Regra de Tributação</h5>-->

      <div v-if="!loadingFinanceiro && finanparcData">

        <div class="text-end mt-5">
          <b-button variant="light" @click="showModalBaixaParc = false">
            <i class="bx bx-block font-size-16 align-middle me-2"></i>
            Cancelar
          </b-button>
          <b-button type="submit" variant="success" class="ms-1" @click="confirmarBaixa">
            <i class="bx bx-check-double font-size-16 align-middle me-2"></i>
            Confirmar
          </b-button>
        </div>
      </div>

    </b-modal>

    <b-modal title="Criar Novo Anexo (Comprovante)" v-model="showModalAnexo" centered hide-footer>
      <div>

        <div class="card-body">
          <h4 class="card-title">Selecionar novo arquivo</h4>
          <DropZone @change="selectedFile" />
          <span class="file-info">Arquivo: {{ dropzoneFile.name }}</span>
          <div v-if="submittedAnexo && !dropzoneFile.name">
            <span class="text-danger font-size-11">Favor selecionar o arquivo e tentar novamente.</span>
          </div>
        </div>

        <div class="card-body">
          <div class="row">
            <div class="col-md-12">
              <label for="descranexo">Descrição</label>
              <div class="position-relative">
                <input id="descranexo" type="text" v-model="descranexo" class="form-control"
                  placeholder="Descrição do anexo" :class="{ 'is-invalid': submittedAnexo && !descranexo }" />
                <div v-if="submittedAnexo && !descranexo" class="invalid-feedback">
                  <span>Campo descrição obrigatório, favor preencher.</span>
                </div>

              </div>
            </div>
          </div>
        </div>


        <div class="text-end mt-5">
          <b-button variant="light" @click="showModalAnexo = false">
            <i class="bx bx-block font-size-16 align-middle me-2"></i>
            Cancelar
          </b-button>
          <b-button type="submit" variant="success" class="ms-1" @click="confAnexo">
            <i class="bx bx-check-double font-size-16 align-middle me-2"></i>
            Confirmar
          </b-button>
        </div>
      </div>

    </b-modal>

    <b-modal title="Condição de Pagamento" v-model="showModalCondPgto" centered hide-footer>
      <router-link to="/condicoes/list" target="_blank">
        <b-button variant="outline-success" title="Criar Cond. de Pagamento" style="padding: 1px 10px"
          @click="enterParcPersonal()">
          <i class="bx bx-customize font-size-15 align-middle me-1" style="cursor:pointer;" />Criar Nova Cond. de
          Pagamento
        </b-button>
      </router-link>
      <div class="col-md-12 mt-3">
        <div class="mb-3">
          <span>Selecionar Condição de Pagamento</span>

          <multiselect id="condpgto" @search-change="pesqCondPgto" @select="escolheuCondPgto"
            v-model="financeiroData.condpgto" placeholder="Pesquisar condição de pagamento"
            :options="dtListPesqCondPgto" :searchable="true" label="descricao" track-by="descricao" value-prop="codigo">
            <template #option="slotProps">
              <div class="row">
                <div>
                  <span class="text-info">
                    {{ slotProps.option.codigo }}
                  </span>
                  <span class="mx-4">
                  </span>
                </div>
                <div class="mt-2 font-size-20">{{ slotProps.option.descricao }}</div>
                <span class="mx-4">
                </span>
                <span class="mx-4">
                </span>
                <div class="align-items-end text-end align-content-end">
                  {{ formatDate(slotProps.option.created_at) }}
                </div>
              </div>
            </template>
          </multiselect>

        </div>
      </div>

      <div class="row" v-if="loadingCondPgto">
        <div class="col-12 text-center">
          <b-spinner type="grow" class="m-6 mx-2" variant="secondary" role="status">
          </b-spinner>
          <b-spinner type="grow" class="m-6 mx-2" variant="secondary" role="status">
          </b-spinner>
          <b-spinner type="grow" class="m-6 mx-2" variant="secondary" role="status">
          </b-spinner>
        </div>
      </div>

      <div v-if="!loadingCondPgto && condPgtoData">
        <div class="mt-4">
          <p class="mb-2">
            Condição de Pagamento Atual
          </p>

          <p class="mb-2">
            Código:
            <span class="text-primary"> {{ condPgtoData.codigo }} </span>
          </p>

          <p class="mb-2">
            Descrição:
            <span class="text-primary"> {{ condPgtoData.descricao }} </span>
          </p>
        </div>




        <div class="text-end mt-5">
          <b-button variant="light" @click="showModalCondPgto = false">
            <i class="bx bx-block font-size-16 align-middle me-2"></i>
            Cancelar
          </b-button>
          <b-button type="submit" variant="success" class="ms-1" @click="confirmarCondPgto">
            <i class="bx bx-check-double font-size-16 align-middle me-2"></i>
            Confirmar
          </b-button>
        </div>
      </div>

    </b-modal>

    <b-alert v-for="(erro, i) in errosValid" :key="`alerta-${i}`" show dismissible variant="danger">
      <i class="mdi mdi-alert me-2"></i>Pendente validação de campo: {{ erro.titulo }} -- {{ erro.mensagem[0] }} --
      favor ajustar e tentar novamente.
    </b-alert>

    <!-- Modal PagBank - Gerar Link de Pagamento -->
    <b-modal title="Gerar Link de Pagamento - PagBank" v-model="showModalPagBank" centered hide-footer size="md">
      <div v-if="!pagbankLinkGerado">
        <div class="mb-3">
          <label for="pagbankSoftdescriptor">Texto na fatura do cliente (Soft Descriptor) <span class="text-danger">*</span></label>
          <input
              id="pagbankSoftdescriptor"
              v-model="pagbankSoftdescriptor"
              type="text"
              class="form-control"
              maxlength="17"
              placeholder="Ex.: NomeEmpresa"/>
          <small class="text-muted">Máx. 17 caracteres ({{ (pagbankSoftdescriptor || '').length }}/17)</small>
        </div>

        <div class="row">
          <div class="col-6">
            <div class="mb-3">
              <label for="pagbankQtdparcelas">Máx. parcelas do cliente</label>
              <input
                  id="pagbankQtdparcelas"
                  v-model.number="pagbankQtdparcelas"
                  type="number"
                  min="1"
                  max="18"
                  class="form-control"/>
            </div>
          </div>

          <div class="col-6">
            <div class="mb-3">
              <label for="pagbankQtdparcelassemjuros">Parcelas sem juros (vendedor assume)</label>
              <input
                  id="pagbankQtdparcelassemjuros"
                  v-model.number="pagbankQtdparcelassemjuros"
                  type="number"
                  min="0"
                  max="18"
                  class="form-control"/>
            </div>
          </div>
        </div>

        <div class="text-end mt-3">
          <b-button variant="light" @click="showModalPagBank = false" class="me-2">
            Cancelar
          </b-button>
          <b-button variant="warning" :disabled="pagbankLoading" @click="gerarLinkPagBank">
            <span v-if="pagbankLoading">
              <span class="spinner-border spinner-border-sm me-1"></span> Gerando...
            </span>
            <span v-else>
              <i class="mdi mdi-credit-card-outline me-1"></i> Gerar Link
            </span>
          </b-button>
        </div>
      </div>

      <div v-else>
        <div class="alert alert-success">
          <strong>Link gerado com sucesso!</strong><br>
          Compartilhe o link abaixo com o cliente para efetuar o pagamento.
        </div>
        <div class="mb-3">
          <label>Link de Pagamento</label>
          <div class="input-group">
            <input
                type="text"
                class="form-control"
                :value="pagbankLinkGerado"
                readonly/>
            <button class="btn btn-outline-secondary" @click="copiarLinkPagBank" title="Copiar link">
              <i class="mdi mdi-content-copy"></i>
            </button>
          </div>
        </div>
        <div class="text-end mt-3">
          <b-button variant="light" @click="showModalPagBank = false">
            Fechar
          </b-button>
          <a :href="pagbankLinkGerado" target="_blank" class="btn btn-warning ms-2">
            <i class="mdi mdi-open-in-new me-1"></i> Abrir link
          </a>
        </div>
      </div>
    </b-modal>

  </Layout>
</template>

<style>
.multiselect-size {
  --ms-max-height: 500px;
}
</style>
